const { APP_NAME, SHORT_DOMAIN, APP_HOST } = window.ThrowdownsConfig;
const year = (new Date()).getFullYear();

export default {
  key: 'es',
  name: 'Español',
  messages: {
    defaultCurrency: 'usd',
    email: 'Email',
    ticket: 'Ticket',
    ticketId: 'Ticket ID',
    lastScan: 'Last Redeemed',
    totalScans: 'Total Redemptions',
    buyTickets: 'Buy Tickets',
    specTickets: 'Spectator Tickets',
    yourTickets: 'Your Tickets',
    print: 'Print',
    buyMoreTickets: 'Buy More Tickets',
    ticketSalesClosedHeader: 'Ticket Sales Closed',
    ticketSalesClosedText: 'Tickets are not currently on sale.',
    loginToBuyTickets: 'Login to buy tickets',
    viewTickets: 'View Tickets',
    buyTicketsToday: 'Buy Tickets Today!',
    tickets: 'Tickets',
    ticketsPanelHeading: 'Tickets',
    ticketsAddingItem: 'Adding Ticket',
    ticketsAddItemButton: 'Add Ticket',
    ticketItemName: 'Ticket Name',
    ticketItemNameDescr:
      'The name of the class of ticket you want to sell (e.g. VIP, Regular, Student)',
    ticketDescriptionDescr: 'A brief description of this class of ticket',
    ticketDescriptionName: 'Ticket Description',
    ticketSalesOpen: 'Open Date for Ticket Sales',
    ticketSalesClose: 'Close Date for Ticket Sales',
    ticketingContent: 'Ticketing Content',
    ticketingContentLead:
      'This content is displayed at the top of your ticket sales page.',
    fieldTypeChoiceFreeResponseOneLine: 'Respuesta Libre - Una Línea',
    fieldTypeChoiceFreeResponseBox: 'Respuesta Libre - Recuadro',
    fieldTypeChoiceMultipleChoicePickOne: 'Opción Múltiple - Elija Una',
    fieldTypeChoiceMultipleChoicePickOneDropdown:
      'Opción Múltiple - Elija Una (Desplegable)',
    fieldTypeChoiceMultipleChoiceCanSelectMultipleAnswers:
      'Opción Múltiple - Puede seleccionar múltiples respuestas',
    pointsTable200Points: '200 Puntos',
    pointsTable100Points: '100 Puntos',
    pointsTable50Points: '50 Puntos',
    pointsTableCustomPoints: 'Puntos Personalizados',
    HigherisBetter: 'Más alto es mejor',
    LowerisBetter: 'Más bajo es mejor',
    tiePolicyTiesStand: 'Posiciones de Empate (Puntos Máximos)      ',
    tiePolicyTiesStandAverage: 'Ties Stand (Puntos Promedio)',
    tiePolicyHigherisBetter: 'Más alto es mejor',
    tiePolicyLowerisBetter: 'Más bajo es mejor',
    scoringPolicyPlacement: 'Colocación',
    scoringPolicyMaxPoints: 'Puntos Máximos',
    scoringPolicyMinPoints: 'Puntos Mínimos',
    scoringPolicyPointsTable: 'Tabla de Puntos',
    pointsTableLabelCustom: 'Personalizar',
    rank: 'Rango',
    leaderboardNameColumnHeader: 'Atleta / Equipo',
    scorer: 'Anotador',
    yes: 'Si',
    no: 'No',
    cancel: 'Cancelar',
    dashboard: 'Tablero',
    manage: 'Gestionar',
    preview: 'Avance',
    registered: 'Registrado',
    submitScores: 'Enviar puntajes',
    yourCompetitions: 'Tus competiciones',
    addCompetition: 'Añadir competencia',
    duplicate: 'Duplicar',
    setup: 'Configurar',
    programming: 'Programación',
    programmingComplete: 'Programming Complete',
    registration: 'Registro',
    registrationComplete: 'Registration Complete',
    payments: 'Pagos',
    paymentsComplete: 'Payments Complete',
    published: 'Publicado',
    publish: 'Publicar',
    requested: 'Pedido',
    request: 'Solicitud',
    inProgress: 'En Marcha',
    login: 'Iniciar sesión',
    location: 'Locación',
    getDirections: 'Obtener dirección',
    date: 'Fecha',
    description: 'Descripción',
    addScores: 'Añadir puntajes',
    view: 'Ver',
    register: 'Registrar',
    now: 'Ahora',
    closed: 'Cerrado',
    leaderboards: 'Tablas de clasificación',
    organizedBy: 'Organizado por',
    contactTheOrganizer: 'Contacta al organizador',
    getDrivingDirections: 'Obtener instrucciones de manejo',
    workout: 'Entrenamiento',
    workouts: 'Entrenamientos',
    division: 'División',
    divisions: 'Divisiones',
    shareWithFriends: 'Compartir con Amigos',
    athleteRegistration: 'Registro',
    tryAgain: 'Inténtelo de nuevo',
    youreRegistered: 'Estas registrado',
    edit: 'Editar',
    youAreRegConfirm:
      `Actualice su <strong><a href='${APP_HOST}/app/my-account/profile'>Perfil del Atleta</a></strong>`,
    charges: 'Cargos',
    card: 'Tarjeta',
    registrationFee: 'Cuota de inscripción',
    appliedCouponCode: 'Aplicado <code>{code}</code>',
    processingFee: 'Procesando pago',
    charge: 'Cargo',
    registerToday: 'Regístrese hoy',
    loginToRegister: 'Para inscribirse en una competición, deberá',
    loginLower: 'Iniciar sesión',
    dontHaveAccount: '¿No tiene una cuenta?',
    createOne: 'Cree una',
    inUnderAMinute: 'en un minuto',
    alreadyRecorded:
      'Ya tienes puntuaciones registradas. No se permiten cambios en su registro.',
    calculatingTotal: 'Calculando el total',
    discount: 'Descuento',
    feeBalance: 'Balance libre',
    totalCharge: 'Cargo total',
    readAndAccept: `He leído y acepto el acuerdo de ${APP_NAME}.`,
    readAndAcceptCompt: 'He leído y acepto el acuerdo {competitionTitle}.',
    updateRegistration: 'Actualizar registro',
    calculateTotal: 'Calcular el Total',
    submitting: 'Enviar',
    allDivisionsAreFull: 'Todas las divisiones están llenas',
    whatDivision: '¿Para que división quieres registrarte?',
    leaderboardName: 'Nombre de la tabla de clasificación',
    leaderboardDescription:
      'El nombre que deseas que aparezca en la tabla de clasificación.',
    memberFormHeading: 'Miembro del equipo {memberIndex} / {registrants}',
    registrantName: 'Nombre del registrante',
    registrantFirstNameDescription: 'Athlete first Name',
    registrantLastNameDescription: 'Athlete last Name',
    registratDescription: 'Nombre del Atleta',
    registrantEmail: 'Dirección de correo electrónico del solicitante',
    registrantEmailDescription: 'Dirección de correo electrónico del atleta',
    coupon: 'Cupón',
    couponIsValid: 'El Cupón es válido',
    couponIsInValid: 'El cupón es inválido',
    enterCoupon: 'Ingrese su código de cupón',
    helpfulLinks: 'Enlaces Útiles',
    privacyTerms: 'Términos & Privacidad',
    throwdownsBlog: `${APP_NAME} Blog`,
    copyright: `© 2014-${year} - ${SHORT_DOMAIN} - Todos los derechos reservados`,
    rotateLeaderboards: 'Rotar las tablas de clasificación',
    filterAthletes: 'Filtrar Atletas',
    athleteName: 'Nombre del Atleta',
    noLeaderboard: 'Aún no se ha publicado ninguna tabla de clasificación',
    loading: 'Cargando',
    points: 'Puntos',
    switchDivisions: 'Cambiar divisiones',
    needPassword:
      'Necesita una contraseña configurada para poder volver a iniciar sesión',
    setPassword: 'Establecer contraseña',
    title: 'Título',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha final',
    venueName: 'Nombre del lugar',
    creatingCompetition: 'Crear competencia',
    beginSetup: 'Comenzar la configuración',
    finishSetupComp: 'Terminar & Establecer la Competencia',
    continue: 'Continuar',
    setupWelcomeIntro:
      `¡Estamos encantados de que estés interesado en ${APP_NAME}!`,
    setupWelcomeMain:
      'Empecemos preparando tu primera competencia. ¡Solo responde algunas preguntas simples para comenzar!',
    setupName: '¿Cuál es el nombre de tu competencia?',
    myCompetitionName: 'Nombre de mi competencia',
    setupKindOnline: 'Es <span class =" comp-name "> {compName} </span> una competencia en línea?',
    setupKindOnlineDescr:
      'Una competencia en línea es donde sus atletas compiten y envían los puntajes en línea desde cualquier parte del mundo en lugar de que los jueces anoten puntajes en el sitio.',
    goBack: 'Regresar',
    whereCompLoc:
      'Donde se realizará <span class=\'comp-name\'>{compName}</span>?',
    venueAddress: 'Dirección del lugar',
    setupCompDate: '¿Cuándo tendrá lugar <span class =" comp-name "> {compName} </span>?',
    timeZoneDescr:
      'La zona horaria para la publicación de tus tiempos de competición.',
    timeZoneDescrLabel: 'Zona horaria',
    start: 'Empezar',
    end: 'Finalizar',
    setupLastStep: '¡Último paso! ¡Solo una cosa más!',
    setupUploadCoverPhoto: 'Sube una foto de portada para <span class =" comp-name "> {compName} </span>',
    suggestedDim: 'Dimensiones sugeridas: {width}x{height}',
    dragOrClickPhoto: 'Arrastre la foto o haga clic para subirla',
    finishCropping: 'Terminar de recortar',
    imageWarning: 'Su imagen es inferior a las dimensiones recomendadas y probablemente se verá borrosa. Recomendamos al menos {recommendedWidth}x{recommendedHeight} y tu imagen tiene {width}x{height}.',
    selectDate: 'Seleccione la fecha',
    setupCongrats: '¡Felicidades! ¡Has preparado exitosamente una competencia!',
    setupQuickSteps:
      '¡Tu página de destino está lista! Quedan solo unos pocos pasos rápidos para lanzar su competencia...',
    launch: 'Lanzar',
    marketingSetupTitlePage: 'El titulo de su pagina',
    marketingSetupCompName: 'Nombre de la competencia',
    marketingSetupCompEmail: 'Contacto por Email',
    marketingSetupCompEmailDesc:
      'La dirección de correo electrónico de contacto principal para este concurso',
    marketingSetupShortlinkDescr: 'El slug en tu URL de competición',
    marketingSetupShortlinkTitle: 'ID del enlace corto',
    marketingSetupUpload: 'Subir una foto de portada',
    marketingSetupMobileUpload: 'Subir una foto de portada para móvil (opcional)',
    marketingSetupPicHelp:
      'Dimensiones sugeridas: {width}x{height}. (Puede desplazarse / hacer zoom / recortar después de subir)',
    marketingSetupOnlineDescr: '¿Es esta una competencia en línea?',
    marketingSetupOnlineTitle: 'Competencia en línea',
    invalidDate:
      'No es válido tener una fecha / hora de finalización antes del inicio.',
    programmingWelcome: '¡Configuremos la programación de {compName}!',
    programmingWelcome2:
      'Revisaremos sus entrenamientos, divisiones y políticas de puntuación durante este proceso de configuración.',
    programmmingDiv: '¿Qué divisiones vas a presentar?',
    programmmingEx:
      'Hemos agregado algunos ejemplos para comenzar. Puede arrastrar y soltar cada división para reordenar su posición en la lista.',
    addDivision: 'Añadir División',
    dragDropDivision: 'Arrastra y suelte las divisiones para cambiar su orden.',
    teamSize: 'Tamaño del equipo',
    teamSizeDescr: 'Deje en 1 si solo es una división de ub solo atleta',
    maxRegistrations: 'Registros Máximos',
    maxRegistrationsDescr:
      '¿Cuál debería ser el límite en el número de registros para esta División?',
    typeOfDivision: 'Tipo de división',
    typeOfDivisionDescr:
      '¿Es esta una división para atletas o para administrar voluntarios y espectadores?',
    athlete: 'Atleta',
    volunteer: 'Voluntario',
    spectator: 'Espectador',
    nameOfDivision: 'El nombre de la División',
    divisionName: 'Nombre de la División',
    loadingDivisions: 'Cargando Divisiones',
    saving: 'Guardando...',
    save: 'Guardar',
    delete: 'Borrar',
    deleteAreYouSure: '¿Estás seguro de que lo deseas eliminar?',
    deleteFieldItemAreYouSure:
      'Are you sure you would like to delete this custom field? Any data collected by this question will be permanently lost.',
    deleting: 'Borrando...',
    programmingWorkouts: '¿Qué Entrenamientos estarás presentando?',
    programmingExamples:
      'Hemos agregado algunos ejemplos para comenzar. Puede arrastrar y soltar cada Entrenamiento para reordenar su posición en la lista.',
    addWorkout: 'Añadir Entrenamiento',
    dragDropWorkouts:
      'Arrastrar y soltar Entrenamientos para cambiar su orden.',
    workoutNameDescr: 'El nombre del Entrenamiento',
    workoutName: 'Nombre del Entrenamiento',
    loadingWorkouts: 'Cargando Entrenamientos...',
    scoringPoliciesUsing: '¿Qué tipo de políticas de puntuación utilizará?',
    scoringLead:
      'Estas configuraciones determinarán cómo se califican los entrenamientos y se usarán para calcular la ubicación del atleta en las tablas de clasificación.',
    dirtyChanges:
      'Usted tiene cambios no guardados. Presione Continuar para guardar tus cambios.',
    scoringType: 'Tipo de puntuación',
    scoringTypeDescr:
      'Seleccione la política de puntuación de la tabla de clasificación a aplicar.',
    scoringOrder: 'Orden de puntuación',
    scoringOrderDescr:
      'Seleccione los ordenes de puntuación que se deben jerarquizar en la tabla de clasificación',
    tieBreakerPolicy: 'Política de desempate',
    tieBreakerPolicyDescr:
      'Selecciona cómo se deben resolver los desempates en la tabla de clasificación.',
    pointsTablePolicy: 'Política de la tabla de puntos',
    pointsTablePolicyDescr:
      'Seleccione la cantidad de puntos que se utilizarán para calcular la ubicación del atleta',
    goYou: '¡Ve tú!',
    programmingConfigured: '¡La programación para <span class="comp-name">{compName}</span> ha sido configurado con éxito!',
    marketingContentTitle: 'Contenido de la página de destino',
    marketingTimeVenueDescr: 'El nombre de tu lugar',
    marketingTimeVenueTitle: 'Nombre del lugar',
    marketingTimeAddressDescr: 'Comience a escribir su dirección',
    marketingTimeAddressTitle: 'Dirección del lugar',
    marketingTimeZoneDescr:
      'La zona horaria para lis tiempos de competición publicados.',
    marketingTimeZoneTitle: 'Zona horaria',
    marketingOnlineHeader: 'Puntuación en línea',
    marketingOnlineSubHeader:
      'Controla cómo se manejan los envíos de puntaje para esta competencia.',
    marketingOnlineWorkouts: 'Entrenamientos',
    marketingOnlineInstr: 'Instrucciones para el envío del puntaje',
    marketingOnlineVideoTitle: 'Enlace de video',
    marketingOnlineVideoDescr:
      '¿Se requiere que el atleta envíe un enlace a un video de su entrenamiento?',
    marketingOnlineImageTitle: 'Imagen',
    marketingOnlineImageDescr: '¿El atleta debe enviar una imagen de su entrenamiento?',
    marketingOnlineJudgeTitle: 'jueza',
    marketingOnlineJudgeDescr: 'O atleta é obrigado a enviar o nome da pessoa que julgou seu treino?',
    marketingOnlineScoreOpens: 'Se abre el puntaje',
    marketingOnlineScoreCloses: 'Se cierra el puntaje',
    optional: 'Opcional',
    required:
      'Requerido (se requerirá que lo provea para poder enviar la puntuación)',
    notOption: 'No es una opción (no se mostrará la entrada)',
    registrationConfig: '¡Configuremos el registro para {compName}!',
    registrationSecondary:
      'Revisaremos sus divisiones, fechas, tarifas y contenido durante este proceso de configuración.',
    finish: 'Terminar',
    registrationWhen: '¿Cuándo debe comenzar y terminar el registro?',
    registrationAvail:
      'Seleccione cuándo estará disponible la inscripción para su evento.',
    registrationOpens: 'Se abre el registro',
    registrationCloses: 'Se cierra el registro',
    registrationCost: '¿Cuánto cuesta registrarse?',
    registrationFeesSet:
      'Las tarifas de inscripción se pueden establecer únicamente por división.',
    preferredCurrency: 'Moneda preferida',
    preferredCurrencyHelp:
      'Su moneda preferida para las transacciones. ** Estas monedas no admiten el uso de AMEX.',
    divisionRegistrationFees: 'Cuotas de inscripción de la división',
    registrationContentMain:
      '¿Algo que decir mientras se registran los atletas?',
    registrationContentSpecial:
      'Si desea que aparezcan instrucciones especiales en la parte superior de su formulario de registro, como las políticas de reembolso u otras cosas importantes para que los atletas sepan antes de comprar boletos, agréguelo aquí. De lo contrario, puede dejar este espacio en blanco.',
    registrationConfigured: '¡El Registro para <span class="comp-name">{compName}</span> ha sido configurado con éxito!',
    accountHeader: 'Su cuenta',
    accountSettings: 'Configuraciones de la cuenta',
    languagePreference: 'Preferencia de idioma',
    accountSubscription: 'Inscripción',
    accountEmailAddress: 'Dirección de correo electrónico',
    accountPassword: 'Contraseña',
    accountConfirmPassword: 'Confirmar Contraseña',
    profileSettings: 'Configuración de perfil',
    profileUsername: 'Nombre de usuario',
    profileUsernamePlaceholder: 'Introduzca un nombre de usuario',
    profileUsernameCanBeSetOnce:
      'Su nombre de usuario solo se puede configurar una vez y no se puede cambiar.',
    profileSetUsername:
      'Configure su nombre de usuario para editar los detalles de su perfil.',
    profileGender: 'Género',
    profileName: 'Nombre',
    profileFirstNamePlaceholder: 'Primer nombre',
    profileLastNamePlaceholder: 'Apellido',
    profileDisplayName: 'Nombre para mostrar',
    profileDisplayNamePlaceholder:
      'Nombre para mostrar preferido en tablas de clasificación',
    profileBio: 'Sobre mi',
    profileBioPlaceholder: `¡Este campo es donde puede enviar detalles adicionales sobre usted como atleta! Muchos de nuestros usuarios incluyen temas como:

    - Rutina de ejercicios
    - dieta
    - Aspectos destacados de la competencia
    - Aficiones

¡Y más! Siempre puede volver y editar su biografía en cualquier momento si no está seguro de qué decir en este momento.`,
    profileAssociationsHeader: 'Asociaciones',
    profileCountry: 'País',
    profileAffiliate: 'Afiliado',
    profileAffiliatePlaceholder: 'Donde entrenas',
    profileSocialHeader: 'Perfiles sociales',
    profileTwitterHandlePlaceholder: 'Tu cuenta de Twitter',
    profileFacebookUsernamePlaceholder: 'Tu nombre de usuario de Facebook',
    profileInstagramHandlePlaceholder: 'Tu manejador de Instagram',
    profileMustSetUsernameToSave:
      'Debe configurar su nombre de usuario para guardar su perfil.',
    profilePublic: 'El perfil es público.',
    profilePrivate: 'El perfil es privado.',
    profilePublicLink: 'Enlace de perfil',
    profilePublicLinkDescr: 'Un enlace para compartir su perfil público.',
    athleteAthleteBio: 'Bio del atleta',
    athleteUsernameNotFound: 'Parece que el perfil no existe.',
    athleteNoBio:
      'Este atleta no ha proporcionado ninguna información biográfica todavía.',
    unspecified: 'Sin especificar',
    onlineScoring: 'Puntuación en línea',
    content: 'Contenido',
    timeAndPlace: 'Tiempo y Lugar',
    help: 'Ayuda',
    coupons: 'Cupones',
    customWaiver: 'Exención personalizada',
    customFields: 'Campos Personalizados',
    scoringPolicies: 'Políticas de puntuación',
    marketing: 'Márketing',
    guidedSetup: 'Configuración guiada',
    retail: 'La Venta al por Menor',
    fees: 'Pagos',
    dates: 'Fechas',
    deposits: 'Depósitos',
    advanced: 'Avanzado',
    registrants: 'Inscritos',
    scoreEntry: 'Ingreso de puntaje',
    management: 'Administración',
    support: 'Soporte',
    dataEntryLinks: 'Enlaces de entrada de datos',
    leaderboardSettings: 'Leaderboard Settings',
    noContent: 'Sin Contenido',
    editContent: 'Editar Contenido',
    registrationContent: 'Contenido de Registro',
    registrationLead:
      'Si desea que aparezcan instrucciones especiales en la parte superior de su formulario de registro, como las políticas de reembolso u otras cosas importantes para que los atletas sepan antes de comprar boletos, agréguelo aquí. De lo contrario, puede dejar este espacio en blanco.',
    connectToAStripeAccount: 'Conectarse a una cuenta de Stripe',
    connectToNewStripeAccount: 'Conectarse a una nueva cuenta de Stripe',
    stripeLead:
      'Nos asociamos con Stripe, el mejor procesador de pagos de la industria, para que siempre tenga un control completo de sus fondos de registro.',
    stripeNotConnected: 'Aún no te has conectado a una cuenta de Stripe',
    letsDoThatNow: 'Hagamoslo ahora',
    yourStripeAccounts: 'Sus cuentas Stripe',
    yourStripeAccountsDescr:
      '¿Cuál de estas cuentas de Stripe debería recibir depósitos para esta competencia?',
    depositsNeedHelp: '¿Necesitas ayuda con los depósitos? Contactanos en',
    youWillReceive: 'Recibirá pagos en su <strong> {acctName} </strong> cuenta de Stripe',
    stripeOptOut:
      'Dado que ha optado por no utilizar Stripe, le cobraremos las tarifas de inscripción. Los fondos se liberarán 45 días después de que termine su competencia y después de evaluar una tarifa de procesamiento de $ 150.',
    registrantDivisionTitle: '{divTitle} Registrados',
    registrantsExport: 'Preparar exportación',
    registrantsExportPrep: 'Preparando...',
    registrantsExportView: 'Ver Exportación',
    registrantsLeaderboardName: 'Nombre de la tabla de clasificación',
    registrantsTeamMembers: 'Miembros del Equipo',
    registrantsAthleteName: 'Nombre del Atleta',
    registrantsDate: 'Registrado en',
    registrantsCharges: 'Cargos',
    registrantsChangeDivision: 'Cambiar División',
    registrantsAddDivision: 'Register for Additional Division',
    addCoupon: 'Añadir Cupón',
    loadingCoupons: 'Cargando Cupones...',
    registrationWaiverContent: 'Contenido de exención de registro',
    registrationWaiverContentLead:
      'Esta exención por defecto debería funcionar bien, pero si usted posee un término que le gustaría que acepten los atletas registrados, simplemente sustitúyalo.',
    addField: 'Añadir Campo',
    customRegistrationFields: 'Campos de registro personalizados',
    loadingRegistrationFields: 'Cargando Campos de Registro',
    label: 'Etiqueta',
    labelDescr: 'La etiqueta para tu campo.',
    helpText:
      'El texto de ayuda para tu campo. Este texto es un \'texto de ayuda\'',
    helpTextLabel: 'Texto de Ayuda',
    requiredField:
      'Se requiere que este campo sea completado durante el registro',
    requiredFieldLabel: 'Se requiere',
    team: 'Team',
    teamField: 'Team Question',
    teamFieldLabel: 'This question will only be asked once per registration',
    fieldChoices: 'Opciones para este campo separadas por comas.',
    fieldChoicesLabel: 'Opciones de campo',
    fieldPreview: 'Vista previa del campo',
    couponCode: 'Código de Cupón',
    percentageOff: 'Porcentaje de Descuento',
    amountOff: 'Cantidad de Descuento',
    numberAvailable: 'Número disponible',
    expiration: 'Expiración',
    add: 'Añadir',
    editCoupon: 'Editar Cupón',
    scoringLink: 'Enlace de puntuación',
    shareThisLink:
      'Comparta este enlace privado y seguro con el personal para obtener ayuda con la puntuación.',
    shareThisTicketLink:
      'Comparta este enlace privado y seguro con el personal para obtener ayuda en la gestión de tickets',
    scoring: 'Puntaje',
    previewLeaderboard: 'Vista previa de la tabla de clasificación',
    publishedLeaderboard: 'Tabla de clasificación publicada',
    refreshing: 'Volver a cargar',
    enterScoresStatement:
      'Ingrese algunos puntajes en la pestaña Puntuación para generar una vista previa en esta pestaña.',
    publishedLeaderboardLink:
      'Esta es la tabla de clasificación publicada disponible en',
    noLeaderboardPublishedStatement:
      'Todavía no has publicado una tabla de clasificación para esta división. Ingrese algunos puntajes en la pestaña Puntuación y luego publique una tabla de clasificación desde la pestaña de Vista previa de la tabla de clasificación.',
    youMadeChangesStatement:
      'Has hecho cambios en el marcador. Previsualiza la tabla de clasificación y publícala para que sea en vivo.',
    noScoresDivision:
      'No hay puntuaciones ingresadas para esta división. Añadir nuevas puntuaciones a continuación.',
    name: 'Nombre',
    addNew: 'Añadir Nuevo',
    score: 'Puntaje',
    tieBreaker: 'Desempate',
    review: 'Revisar',
    yourScores: 'Tus Puntajes',
    scoresFor: 'Resultados para',
    mustAuth: 'Debes autenticar para registrar tus puntuaciones',
    instructions: 'Instrucciones',
    scaled: 'Escalado',
    video: 'Video',
    withdraw: 'Renunciar',
    scoringClosed: 'Puntuación cerrada',
    withdrawing: 'Abandonar',
    scoringIsOpenFrom: 'La puntuación está abierta desde',
    addScore: 'Añadir Puntaje',
    scoringIsClosed: 'La puntuación está cerrada',
    window: 'Ventana',
    scoreDescr: '¿Cuál fue su puntuación?',
    timeScoreDescr:
      'Ingrese el tiempo que tomó completar el entrenamiento completo.',
    repScoreDescr:
      'Ingrese el número de repeticiones que pudo completar dentro del límite de tiempo.',
    tieBreakDescr: '¿Cuál fue tu desempate?',
    certification: 'Certificación',
    rx: 'Rx',
    rxCertifyStatement:
      'He completado el ejercicio según lo establecido por escrito para esta división.',

    scaledCertifyStatement:
      'I understand my scores will rank below athletes who followed the standards in this division.',
    selectRxStatement:
      'Selecciona Rx si haz completado el ejercicio según establecido <strong>para tu división</strong>. De lo contrario, seleccione Scaled para indicar que no hiciste el ejercicio según lo establecido <strong>para tu división</strong>.',
    certificationHelp: 'Marque esta casilla si no modificó los estándares de su división (pesos más ligeros, movimientos modificados, etc.)',
    certificationDescription: 'Dejar esta casilla vacía significa que modificó el entrenamiento de alguna manera. Tus puntuaciones aparecerán en la parte inferior de la tabla de clasificación.',
    videoLink: 'Enlace de video',
    videoLinkDescr:
      'Enlace del video de su entrenamiento de YouTube u otro gestor de alojamiento de videos',
    imageLink: 'Imagen',
    imageLinkDescr: 'Cargue una imagen para usarla en la verificación de la puntuación',
    judge: 'Jueza',
    judgeDesc: 'El nombre de la persona que observó su entrenamiento',
    comments: 'Comentarios',
    expired: 'Caducado',
    expiresOn: 'Expira el ',
    extend: 'Ampliar',
    expire: 'Expirar',
    activate: 'Activate',
    deactivate: 'Deactivate',
    active: 'Active',
    inactive: 'Inactive',
    externalScoreThanks: '\'¡Gracias por ayudar a anotar!',
    hangTight: 'Aguanta',
    exitWithoutSavingSure: '¿Seguro que quieres salir sin guardar?',
    continueEditing: 'Continua editando',
    exitWithoutSaving: 'Salir sin guardar',
    finalReviewStatement:
      '¡Tu competencia está en proceso de revisión final antes de su lanzamiento!',
    dashboardSummary: 'Un resumen de cómo va tu competencia.',
    summary: 'Resumen',
    revenue: 'Ingresos',
    views: 'Vistas',
    registrations: 'Registros',
    outOf: 'fuera de',
    divisionCapacity: 'Capacidad de la división',
    by: 'Por',
    cumulativeTotalRevenue: 'Ingresos totales acumulados',
    performance: 'Desempeño',
    regAndTrafficStatement:
      'Registros y tráfico de la página de inicio de su competencia a lo largo del tiempo.',
    scoreSubmissionHeader: 'Envío de las puntuaciones del atleta',
    athleteAlreadyExists: 'El atleta ya entró',
    workoutSubmitScore: 'Enviar puntuación',
    only: 'Solo',
    spots: 'Lugar | Lugares',
    remaining: 'restante',
    stripeDeclined: 'Tu tarjeta fue rechazada.',
    stripeInsufficient: 'Su tarjeta no tiene fondos suficientes.',
    twitterMessage: '{compName} se ve bien. Check this out:\n\n{href}',
    shareEmailSubject: 'Verificar{compName}',
    shareEmailMessage: '{compName} se ve bien. Check this out:\n\n{href}',
    deleteCouponMessage: '¿Está seguro de que desea eliminar el <strong>{code}</strong> Cupón?',
    unsupportedBrowHead: 'Navegador no soportado',
    unsupportedBrowButton: 'De acuerdo',
    unsupportedBrowDescr: 'Parece que estás usando un navegador antiguo no compatible. Puede que tenga dificultades para utilizar la aplicación. Por favor actualicelo para asegurarse de obtener la mejor experiencia.',
    networkErrorHead: 'Error de red',
    networkErrorButton: 'Inténtalo de nuevo',
    networkErrorDescr: 'Se perdió tu conexión de red',
    clipboardCopy: '¡Copiado!',
    waiverClose: 'Cerrar Renuncia',
    waiverShow: 'Mostrar Renuncia',
    couponDiscount: '{discount}% de descuento',
    failedRegistration: 'Hay un Problema',
    competitionFullHeader: 'La competencia está completa',
    divisionsFullDescr:
      'Se han vendido todas las divisiones. Favor de contactar al organizador para preguntar sobre la lista de espera.',
    totalRepsInWorkout: 'Recuento Total de Repeticiones',
    totalRepsInWorkoutNA: 'Recuento Total de Repeticiones - N/A',
    totalRepsInWorkoutDescr:
      'Si este entrenamiento tiene un límite de tiempo e implica contar el número de repeticiones que se completaron, ingrese el recuento total de repeticiones del entrenamiento. Deje el campo en blanco si no aplica.',
    minimumWorkNotMet: 'Trabajo mínimo no cumplido',
    minimumWorkRequired: 'Trabajo Mínimo Requerido',
    minimumWorkRequiredDescr: 'Si la puntuación de un atleta no alcanza o supera este valor para el entrenamiento, se moverá al final de la tabla de clasificación general.',
    timeCap: 'Límite de Tiempo',
    timeCapDescr:
      'Si este entrenamiento tiene un límite de tiempo, ingréselo usando horas, minutos y segundos.',
    invitationInviteesCount: 'Invitee(s)',
    registrationRequiredFieldsWarning:
      'Please fill out all the required fields.',

    subtotal: 'Subtotal',
    regCardEndingMessage:
      'Está realizando esta transacción en una tarjeta que termina con',
    merchandise: 'Mercancía',
    orderMerchItem: 'Artículo',
    orderMerchPrice: 'Precio',
    orderMerchQty: 'Cant',
    orderMerchSoldOut: 'Agotado',
    orderMerchCouponDis: 'Cupón de Descuento',
    orderMerchSubtotalDis: 'Subtotal Descontado',
    orderMerchNow: 'Ordenea Ahora',
    merchHeader: 'Artículos al por Menor',
    merchAddItem: 'Añadir un Artículo a la Venta',
    merchQty: 'Cantidad Inicial',
    merchQtyDescr: '¿Cuántos de estos tienen disponibles para la venta?',
    merchExchangeable: 'Intercambiable',
    merchExchangeableDescr:
      '¿Es este artículo algo que es intercambiable por un artículo diferente?',
    merchItemName: 'Nombre del Artículo',
    merchItemNameDescr: 'El nombre del artículo a la venta',
    addItemDescrHeader: 'Item Description',
    addItemDescrDescr: 'Pequeña descripción de tu producto',
    merchImageUpload: 'Subir una imagen para el artículo',
    merchImageHelp:
      'Dimensiones sugeridas: {width}x{height}. (Puede desplazarse/hacer zoom/recortar después de subir)',
    merchLoading: 'Cargando Artículos para la Venta...',
    orderMerchButton: 'Ordenar Mercancía',
    editDetailsButton: 'Editar Detalles',
    releaseTime: 'Tiempo de Liberación',
    releaseTimeDescription:
      'Selecciona a qué hora desearía hacerles saber los detalles del ejercicio a los atletas. Ejercicios después del ‘Tiempo de Liberación’ tendrán un marcador de ‘TBA Ejercicio’.',
    invalidVideo: 'Video Invalido',
    athleteComment: 'Comentario del Atleta',
    exportAsCSV: 'Exportar como CSV',
    scoringImportAthletes: 'Importar',
    scoringImportAthletesDescr:
      'Pegar en el nombre de tus atletlas para añadirlos a la tabla de puntajes.',
    importingAthletes: 'Importando...',
    bibNumbers: 'Numero Bib',
    enterBibNumber: 'Ingrese su Número Bib',
    toggleBibs: 'Alternar Bibs',
    noWorkoutFound: 'No se encontraron ejercicios',
    noWorkoutFoundDescr: 'No existe este ejercicio.',
    noDivisionFound: 'No se encontró la división',
    noDivisionFoundDescr: 'No existe esta división.',
    merchReceiptQty: 'Cantidad',
    merchPurchasedItems: 'Objetos comprados',
    registrationClosedBody: 'Registro Cerrada',
    registrationClosedBodyDescr: 'El registro ya está cerrado.',

    competitionCard: {
      duplicateAlert: '¿Seguro que quieres duplicar esta competición?'
    },
    divisionTeamReqMessage: '{teamSize}-miembros requeridos para el equipo',
    throwdownsWaiver: `<h4>Asunción de riesgo y acuerdo de liberación de responsabilidad</h4>
                <p>En consideración de que se me permita participar de cualquier manera en el programa, eventos relacionados y actividades, reconozco y acepto que:</p>
                <ul>
                <li>El riesgo de lesiones por las actividades involucradas en este programa es significativo, incluido el riesgo potencial de parálisis permanente y muerte.</li>
                <li>Asumo enterado  y libremente todos estos riesgos, tanto conocidos como desconocidos, incluso si estan relacionados con la negligencia de los lanzamientos u otros factores, y asumo toda la responsabilidad de mi participación.</li>
                <li>Estoy dispuesto a cumplir con los términos y condiciones de participación. Si observo algún peligro significativo inusual durante mi presencia o participación, me retiraré de la competencia y lo señalaré inmediatamente al funcionario más cercano.</li>
                <li>Yo, por mí mismo, y en nombre de mis herederos, ejecutores, administradores, representantes personales, sucesores y cesionarios, renuncio y libero todos y cada uno de los derechos, reclamos y cursos de acción que tengo o puedo tener contra los organizadores o cualquier persona asociada con la entidad ,  el patrocinador principal y sus afiliados, sus agentes, empleados, funcionarios, directores, sucesores y cesionarios, la empresa de gestión de eventos, la ciudad, los distritos de parques y todos y cada uno de los patrocinadores, sus representantes y sucesores, que puedan surgir como resultado de mi participación en el evento y en cualquier actividad previa y posterior al evento.</li>
                <li>Certifico y verifico que estoy en buena forma física y que he recibido suficiente capacitación para completar este programa, eventos relacionados y / o actividades relacionadas, y un médico con licencia ha verificado mi condición física.</li>
                <li>Además, por la presente otorgo un permiso completo a cualquiera y todos los anteriores para utilizar cualquier fotografía, imágenes en movimiento, grabaciones o cualquier otro registro de este evento para cualquier propósito legítimo, incluida la publicidad comercial.</li>
                <li>Verifico que soy mayor de 18 años o que tengo el consentimiento de mis padres para participar en un ejercicio físico intenso.</li>
                </ul>`,

    setupProgramming: '@:Configuración @:Programar',
    setupRegistration: '@:Configuración @:Registro',
    setupPayments: '@:Configuración @:Pagos',
    publishRequested: '@:Publicación @:Solicitada',
    requestPublish: '@:Solicitar @:Publicación',
    viewRegistration: '@:Ver @:Registro',
    registerNow: '@:Registrar @:Ahora',
    buyTicketsHeader: 'Buy Tickets Today',
    registrationClosed: '@:Registro @:Cerrado',
    noWorkoutForThisDivision: '@:No @:entrenamiento para esta @:divisón',
    noDivisionsForThisWorkout: '@:No @:divisiones para este @:entrenamientos',
    yesDelete: '@:Si, @:Borrar',

    heatScheduling: 'Horario',
    heatsSubMenu: 'Controlar series',
    heatsLocations: 'Lugares',
    heatsWorkoutLocations: 'Lugares para Ejercitar',
    heatsSchedules: 'Horarios',
    heatsSegments: 'Segmentos',
    athleteAssignmentsLabel: 'Athletes',
    heatManageAssignments: 'Heat and Lane Assignments',
    heatsManageTimes: 'Controlar Series',
    schedule: 'Horario',
    heatsJudges: 'Jueces',
    loadingLocations: 'Cargando lugares...',
    addLocation: 'Añadir lugar',
    heatsWorkoutParams: 'Parámetros de la ronda de ejercicios',
    workoutDurationDesc:
      'La cantidad de tiempo (minutos) asignado por atleta para completar este ejercicio',
    workoutDurationLabel: 'Duración',
    configStartEnd: 'Hora',
    actualStartEnd: 'Hora',
    workoutTransitionTimeDesc:
      'La cantidad de tiempo (minutos) asignado para la transición entre atletas ',
    workoutTransitionTimeLabel: 'Tiempo de Transición',
    workoutNumberOfLanesDesc:
      'Cantidad de líneas disponibles para este ejercicio',
    workoutNumberOfLanesLabel: 'Numero de Líneas',
    workoutTimeCapDescr:
      'El límite de tiempo para este entrenamiento es de {timeCap}',
    workoutTimeCapAllRepsCompleted:
      '<strong>Las {totalRepsInWorkout} repeticiones</strong> se completaron dentro del límite de tiempo límite de tiempo.',
    workoutTimeCapFewerRepsCompleted:
      '<strong>Se completaron menos de {totalRepsInWorkout} repeticiones</strong> dentro del límite de tiempo.',
    heatsLaneEmpty: '{laneLabel} Vacía',
    heatsJudgeLaneEmpty: 'La línea está vacía',
    heatsLane: 'Linea {athleteIndex}',
    heatsPending: 'Atleta Pendiente',
    calculating: 'Calculando...',
    publishing: 'Publicando...',
    heatsStartEnd: 'Tiempos de Inicio y Salida',
    heatsStartEndDescr:
      'La hora deseada de inicio y salida para el horario de este día',
    heatsTransTime: 'Hora de Transición',
    heatsTransTimeDescr:
      'Tiempo de transición entre la finalización de un ejercicio/división y el comienzo del siguiente. Incrementa 5 minutos.',
    lane: 'Línea',
    backToTop: 'Volver arriba',
    back: 'Fondo',
    next: 'Siguiente',
    empty: 'Vacío',
    printCancel: 'Cancelar Impresión',
    heatsNoPlans: 'Nada planeado',
    heatsStageWorkouts: 'Ejercicios para este lugar',
    heatsStageWorkoutsDescr:
      'Selecciona y ordena los ejercicios que harán en este lugar para cada día de tu competencia.',
    stageNameDescr:
      'El nombre del lugar que estas creando. Ejemplo: levantando el estante, plataforma de mancuerna, lago, pista, etc.',
    locationName: 'Nombre del lugar',
    schedulingConfig:
      '¡Vamos a establecer unas configuraciones iniciales para el horario de las rondas!',
    schedulingSecondary:
      'Durante este proceso de configuración pasaremos por tres secciones: Creando los distintos segmentos de tiempo de tu horario, estableciendo los lugares de los ejercicios, y estableciendo parámetros importantes para el ejercicio, como la duración y el número de líneas.',
    schedulingSegments:
      'En este paso, configuraras el horario de inicio y final de cada segmento de tu competencia. Te hemos proporcionado algunos segmentos por defecto para ti basado en el número de días que durara tu competencia.',
    schedulingStages:
      'En esta configuración, crearas tus lugares de trabajo y asignaras ejercicios a él. Piensa en los lugares como distintas estaciones o las sedes de trabajos serán completadas ahí. Te hemos proporcionado lugares muestra.',
    schedulingWorkouts:
      'En este paso, ajustaras varios parámetros para el ejercicio que se te ha asignado en ese lugar. Estos parámetros incluyen la duración, tiempo de transición y el número de líneas. Te hemos proporcionado unos valores por defecto para que puedas empezar.',
    schedulingConfigured:
      '¡Los pasos iniciales para crear tu horario de rondas ha sido configurado exitosamente!',
    schedulingFinal:
      'Siguiente, pasaras a la pestaña de horario, aquí versa como tu(s) horario(s) se ‘dividirán’ en diferentes secciones de tiempo.',
    schedulePageTitle: 'Horario',
    scheduleYours: 'Tú Horario',
    loginSchedule: 'Para ver tú horario,',
    missingDataWarning:
      'La competencia no se ha configurado adecuadamente por el horario para poder correr. Si quiere diseñar un horario, necesita resolver los siguientes requerimientos y revisar otra vez aquí:',
    noDivisionsWarning: 'No se han definido divisiones para esta competencia.',
    noWorkoutsWarning: 'No se han definido ejercicios para esta competencia.',
    noStagesWarning:
      'No se han definido lugares para el horario de esta competencia.',
    schedulingInfo:
      'Desde esta pestaña, podrás ver y controlar los distintos segmentos que has creado. Da click en el menú desplegable para tener una vista detallada de tu segmento, donde puedes establecer el orden de las divisiones y establecer las transiciones globales de tiempo ',
    schedulingPanelInfo:
      'Por debajo están las diferentes divisiones de tu competencia. Las divisiones pueden ser reordenadas cada una de ellas por separado.',
    schedulePageInfo:
      'Ningún horario ha sido publicado todavía para esta competencia. Para más información, contacte al organizar de eventos usando el correo electrónico que se encuentra abajo.',
    confirmPublish: 'Confirmar',
    addSegment: 'Añadir Segmento',
    segmentTitle: 'Titulo de Segmento',
    segmentTitleDesrc: '¿Cuál es el nombre de este segmento?',
    loadingSegments: 'Cargando Segmentos...',
    heatsDraft: 'Draft',
    minute: 'minuto',
    minutes: 'minutos',
    second: 'segundo',
    seconds: 'segundos',
    seedingInfo:
      'Desde esta pestaña, Puedes modificar las cabezas de serie. Se han ordenado aleatoriamente los atletas a la cabeza de series. Da click en el menú desplegable para anular esta cabeza de serie atleta por atleta. Números más bajos indican una mejor clasificación en la cabeza de serie (1 > 4).',
    manageHeatsInfo:
      'Desde esta pestaña, podrás ver y controlar las rondas de cada horario que has creado. Da click en el icono de menú desplegable para ver y cambiar la asignación de líneas por ronda base.',
    timeBlockLabel: 'Time Box Only',
    timeBlockDesc:
      'This segment will not have any heats but rather just be a box of time on your schedule.',
    timeBlockCheckBoxText: 'Yes, flag as a time box segment.',
    expand: 'Expandir',
    heatsNoJudges: 'Todavía no hay jueces asignados',
    configuration: 'Configuración',
    defaultErrorMessageSavingJudgeName:
      'Error al Guardar. ¡Intenta nuevamente!',
    heatsNoHeatsSegment: 'No hay nada agendado para este segmento todavía ',
    deleteConfirm: 'Borrado',
    schedulePublishWarning:
      'Hará el horario público y permitirá ver a los atletas sus rondas personales.',
    scheduleUnpublishWarning:
      'Eliminar la publicación removerá el horario de la página de aterrizaje publica y ocultará las rondas de los atletas. ¿Estás seguro?',
    heatsLastSegmentWarning:
      'Debes tener al menos un segmento y este es el único que tienes.',
    heatsLastLocationWarning:
      'Debes tener al menos un lugar para ejercitarte y este es el único que tienes.',
    heatsDeletePublishedLocationWarning:
      'Uno o más segmentos sados en este lugar están en un horario publicado.',
    heatsSchedulesNoWorkout: 'Sin ejercicios asignados.',
    heatsSchedulesAssignWorkout: 'Asignar alguno.',
    heatsSchedulesInvalidWarning:
      'Parámetros inválidos. No se puede procesar el horario.',
    heatsSwappingNotification:
      'Selecciona otro atleta en este ejercicio para cambiar líneas/rondas.',
    heatsSeedsNoAthletes: 'No hay atletas registrados en esta división ',
    heatsFetchRegistrations: 'Buscando registros...',
    heatsHeatsJudgesInvalidSchedule:
      'El horario para este segmento es invalido. Favor de corregir para continuar.',
    heatsSchedulesPublishedWarning:
      'No puedes realizar cambios aquí porque este segmento del horario esta publicado.',
    heatsCreated: 'Creado',
    heatsSchdulesTimeOverSegmentWarning: 'Tu horario esta <strong>{timeOver} minutos</strong> después del final del segmento. Puedes ajustar la transición entre divisiones, parámetros de ejercicios y/o tiempos finales de los segmentos para resolver esto.',
    heatsPreviewInstructions: 'Esta es una vista previa de lo que se publicara en tu página de aterrizaje. Cada <em>Segmento</em> es publicado individualmente, permitiéndote ampliar los horarios cuando estés listo.',
    heatsPreviewRegOpenWarning:
      'No se puede publicar hasta que se cierren los registros ',
    unpublish: 'Quitar publicación',
    confirmUnpublish: 'Quitar publicación',
    areYouSure: '¿Esta seguro?',
    areYouSurePublish: '¿Esta seguro que está listo para publicar?',
    areYouSureUnpublish:
      '¿Esta seguro que está listo para quitar la publicación? ',
    unpublishWarningIntro:
      'Después de quitar la publicación, ciertas acciones pueden causar que su horario sea completamente regenerado: ',
    unpublishWarningDivisions: 'Añadiendo o borrando divisiones ',
    unpublishWarningWorkouts: ' Añadiendo o borrando ejercicios',
    unpublishWarningAdvancedWorkouts:
      'Excluyendo o incluyendo ejercicios en las divisiones como parte de una política de control de puntuación avanzada ',
    unpublishWarningWorkoutHeats:
      'Cambiando los parámetros de ejercicios de las rondas',
    unpublishWarningWorkoutLocations:
      'Añadiendo o borrando los lugares para ejercitarte ',
    unpublishWarningWorkoutLocationsConfig:
      'Cambiando la configuraciond e tus lugares para ejercitarte ',
    unpublishWarningSeeding: 'Modificando la cabeza de serie del atleta ',
    unpublishWarningBody:
      'Haciendo cualquiera de los de abajo después de quitar una publicación resultara en la regeneración de tu horario. Esto significa que cualquier juez que hayas ingresado será perdido y los tiempos/lugares que tus atletas han visto se cambiaran probablemente.',
    pleaseConfirm: 'Favor de confirmar',
    unpublishWarningTypePublish:
      'Escribe \'unpublish\' para confirmer que quieres hacerlo.',
    heatsPreviewInvalidWarning: 'Horario invalido. Corregir antes de publicar.',
    heatInvalidStartHere: 'Empezar aquí.',
    publishedScheduleWarningHeader: 'Tienes un horario publicado ',
    /// Translators: The next three entries are together, and need to be translated as one sentence.
    publishedScheduleWarningBody1: 'Debes',
    publishedScheduleWarningBody2: 'eliminar publicación',
    publishedScheduleWarningBody3: 'para hacer los cambios.',
    /// End grouping...

    /// The below translation is led with a competition name, like "Comp1 has been submitted for review!"
    launchModalHeader: 'se ha enviado para su revisión',
    launchModalLead1:
      '¡Impresionante! Creaste con éxito tu competencia y nos la enviaste para su revisión',
    launchModalLead2: 'Nuestro personal:',
    launchModalList1: 'Revisará los detalles de su competencia',
    launchModalList2: 'Le informará sobre nuestras diferentes opciones de pago',
    launchModalList3:
      'Confirmará la fecha en que desea publicar su competencia',
    launchModalLead3:
      '¡Estamos orgullosos de asociarnos con usted para lanzar una competencia increíble!',
    launchModalButton: '¡Genial! ¡Hagámoslo!',

    intentModalHeader: `¡Bienvenido a ${APP_NAME}!`,
    intentModalIntro:
      '¡Estamos encantados de que comience! Ayúdenos a personalizar su experiencia contándonos sobre usted',
    intentModalOptionSelect: 'Sí quiero:',
    intentModalParticipant: 'Soy un participante',
    intentModalParticipantDescr1: 'Registrarse para una competencia',
    intentModalParticipantDescr2: 'Ver tablas de clasificación',
    intentModalParticipantDescr3: 'Descubrir nuevas competiciones',
    intentModalParticipantButton: 'Comience aquí',
    intentModalOrganizer: 'Soy un organizador',
    intentModalOrganizerDescr1: 'Crear y gestionar una competencia',
    intentModalOrganizerDescr2: 'Agregar/revisar puntajes',
    intentModalOrganizerDescr3: 'Publicar tablas de clasificación',
    intentModalOrganizerButton: 'Comience aquí',
    intentModalSpectator: 'I am a Spectator',
    intentModalSpectatorDescr1: 'Buy tickets for a competition',
    intentModalSpectatorDescr2: 'View leaderboards',
    intentModalSpectatorDescr3: 'Discover new competitions',
    intentModalSpectatorButton: 'Start Here',

    dashboardOrganizerNoComps:
      'Aún no ha creado ninguna competencia. <strong> ¡Agregue una competencia </strong> para comenzar!',
    dashboardParticipantNoComps:
      'Actualmente no estás registrado para ninguna competencia. <strong> ¡Encuentre una competencia </strong> para comenzar!',
    dashboardSpectatorNoComps:
      'You currently don\'t have tickets to any competitions. <strong>Find a Competition</strong> to get started!',
    scoreubModalClose: 'Cerrar',
    AthleteToggle: 'Participante',
    organizerToggle: 'Organizador',
    spectatorToggle: 'Spectator',
    findCompButton: 'Encuentra una competencia',
    findCompHeader: 'Encuentra una competencia',
    findCompSearchHeader: 'Buscar un concurso',
    findCompSearchDescr:
      'Busque un concurso por el nombre para encontrar uno en el que esté interesado en registrarse',
    findCompSearchResults: 'Resultados de búsqueda',
    findCompResultLandingPage: 'Página de destino',
    findCompFetchLocation: 'Obteniendo ubicación...',
    findCompUseLocation: 'Usar mi ubicación',
    findCompFetchSuggestions: 'Obteniendo sugerencias...',
    findCompRecentlyViewed: 'Visto recientemente',
    findCompNoSuggestions: 'No se encontraron sugerencias',
    findCompFetchSearchResults: 'Obteniendo resultados de búsqueda...',
    findCompNoSearchResults:
      'No encontramos ningún concurso que coincida con sus términos de búsqueda',
    findCompSuggestions: 'Sugerencias',

    acceptTerms: 'I accept the',
    latestTerms: 'latest terms of service',
    submitConsent: 'Accept',
    tosUpdated: 'Our Terms of Service has been updated!',

    launchPublishModal: 'Launch Your Competition!',
    readyToLaunch: 'Lets do this!',
    areYouReadyToLaunch:
      '<p class=\'lead\'>Launch your Competition</p><p>It\'s free for you to launch a competition. Participants pay processing fees when they register per the terms of service.</p>',

    bibNumber: 'Bib #',
    registrationAccess: 'Registration Access',
    registrationAccessHeader: 'Registration Access',
    registrationAccessCheckboxMessage:
      'Allow athletes to update their registrations',
    registrationAccessDescr: 'Por defecto, los atletas pueden actualizar sus datos de registro en cualquier momento. Esto incluye cambiar cualquier respuesta de campo personalizada, así como cambiar su división. Desmarcar esta opción evitará que los atletas puedan actualizar su información de registro o cambiar su división después de registrarse.',
    regDetailDescription: 'Description',
    regDetailQuantity: 'Quantity',
    regDetailRegistration: 'Registration',
    regDetailPurchases: 'Purchases',
    regDetailAdd: 'Add',
    regDetailDivision: 'Division',
    regDetailBib: 'Bib #',
    regDetailLeaderboardName: 'Leaderboard Name',
    regDetailTeamMember: 'Team Member #',
    regDetailEmail: 'Email',
    invitationsMenuLabel: 'Invitations',
    invitationPageHeader: 'Invitations',
    createInvitationLabel: 'Create',
    manageInvitationsLabel: 'Manage',
    createInvitationPageHeader: 'Create an Invitation',
    createInvitationPageIntro:
      'Compose your message, add and rank your invitees, and save as you go.  Hit Publish when you are ready to start sending your invites.',
    invitationFormLabelMustMatch: 'Email Must Match',
    invitationFormHelpMustMatch: 'The email of the accepting user must match the email that was invited.',
    invitationFormLabelLabel: 'Invitation Label',
    invitationFormLabelDescription:
      'The name of your campaign. This is a reference for your use only.',
    invitationFormLabelDivision: 'Division',
    invitationFormHelpDivision:
      'The division to invite someone to.  Setting it blank allows the invitee to pick their division.',
    invitationFormHelpDivision2:
      'Invites with unassigned divisions may not have a registration slot reserved for them due to sellouts.',
    invitationFormLabelExpireDays: 'Expire Days',
    invitationFormHelpExpireDays:
      'The number of days from when the email is sent to when the invitation expires. Setting it blank means invitations never expire and all emails will be sent an invitation once published.',
    invitationCampaignsHeader: 'Invitation Campaigns',
    invitationCampaignsLead: 'Create and manage your invitation campaigns.',
    invitationCampaignsHelp:
      'Click on the invitation “Label” to get a detailed view on your campaign status.',
    invitationDetailHelpText:
      'Your invitation has been scheduled to send and will start going out shortly.',
    invitationStopWarning:
      'Pressing this button will stop this campaign from sending any more invites and end the campaign permanently.',
    invitationStopHelp:
      'Stopping this invitational will prevent any more invites from being sent, but will not revoke any invites that have already been delivered. Are you sure you want to proceed?',
    invitationPublishConfirmHelp:
      'Publishing your invitation campaign will make it live and start the process of sending out invites. Once you publish, you will not be able to edit your email, add more invites, or rearrange invite order. Are you sure you are ready to publish?',
    publishConfirm: 'Yes, Publish',
    inviteOnlyCompRegistrationHelpText:
      'You must receive an invite to register for this competition. Please reach out to your organizer for more information.',

    saveDraft: 'Save Draft',
    createInvitationDraft: 'Create Invitation Draft',
    compose: 'Compose',
    invite: 'Invite',
    saveInviteList: 'Save Invitees',
    inviteMessagePreviewLoading: 'Rendering Preview...',
    invitationsEmailImportLabel: 'Import Email Addresses',
    invitationsEmailImportHelpText:
      'Copy and paste email addresses of those you wish to invite (either one per line or comma/space delimited)',
    manageInvites: 'Manage Invites',
    addInvites: 'Add Invites',
    inviteDetailEmail: 'Email',
    inviteDetailSent: 'Sent',
    inviteDetailExpires: 'Expires',
    inviteDetailStatus: 'Status',
    inviteStopCampaign: 'Stop Campaign',
    inviteStop: 'Stop',
    inviteConfirmStop: 'Yes, Stop',
    inviteDetailDescr:
      'Invites will be sent based on priority, starting from the top of the list.  As invitations are accepted or expire, more will be sent. Once all invites have been sent or have expired, the campaign will end.',
    inviteDetailExpireDays: 'Invitations will expire <strong>{invitation_expire} day(s)</strong> from when they are sent.',
    inviteManageLabel: 'Label',
    inviteManageStatus: 'Status',
    inviteManageTotalInvites: 'Total Invites',
    inviteManageSent: 'Sent',
    inviteManageAccepted: 'Accepted',
    invitationFormLabelMessageHeader: 'Brief message (optional)',
    invitationFormLabelMessageDescr:
      'We will include this message in the generated invitation email.',
    inviteStatusExpired: 'Expired',
    inviteStatusAccepted: 'Accepted',
    inviteStatusDeclined: 'Declined',
    inviteStatusBadEmail: 'Bad Email Address',
    inviteStatusPending: 'Pending',
    inviteDefaultMessage: 'We are happy to invite you to register for {message}!',
    invitationManageSecHeader:
      'Drag and drop to re-order invitees. Invites will be sent based on priority from top to bottom.',
    invitePublishedTime: 'Published at',
    inviteDeleteInvitee: 'Delete',

    registrationInvites: 'Invites Required',
    registrationInviteRequiredHeader: 'Invitation Requirement',
    registrationInviteRequiredCheckboxMessage: 'Require Invites to Register',
    registrationInviteRequiredDescr:
      'If selected, registration will be closed to the public and only accessible via an invitation.',
    invitationRequiredToRegister: 'Invitation Required for Registration',
    invalidInviteCodeHeader: 'Invalid Invitation Code',
    invalidInviteCodeText: 'This code has already been used or does not match the intended recipient.',

    publishWarningHeader: 'Competition is unpublished',
    publishWarningDescr:
      'This feature is not available until your competition is published.',
    invitationFormNullDivWarning:
      'Are you sure you don\'t want to assign a division?',
    invitationFormInviteEmailAddress: 'Email Addresses',
    invitationFormInvitePrevComps: 'From Previous Competition',
    invitationRegistrantSelectCompHeader: 'Competition',
    invitationRegistrantSelectCompDescr:
      'Select the competition to invite registrants from',
    invitationRegistrantSelectDivHeader: 'Division',
    invitationRegistrantSelectDivDescr:
      'Select the division to invite registrants from',
    invitationLoadDivisions: 'Loading divisions...',
    invitationLoadRegistrants: 'Loading registrations...',
    invitationRegSelectorHead: 'Registrations',
    invitationRegSelectorDescr: 'Registrations are ordered by their leaderboard placement in <strong>{source_comp}</strong>',
    invitationSelectTop: 'Select Top',
    invitationSelectTopDescr:
      'Select all registrants or enter a number to select the top X athletes to be added to this campaign.',
    invitationNoRegistrants: 'There are no registrations in this division.',
    leaderboardSettingsSubHeader:
      'Customize your leaderboard by adjusting the following settings.',
    leaderboardFlagEnabledMessage:
      'Cuando se alterna, muestra la bandera del país del atleta. Si el atleta no ha establecido su país en su perfil, no se mostrará ninguna bandera.',
    sponsorship: 'Patrocinio',
    sponsors: 'Patrocinadores',
    manageSponsors: 'Administrar patrocinadores',
    sponsorsSubHeader:
      'Cree patrocinadores, agregue enlaces de afiliados y suba activos de imagen para usar en campañas publicitarias.',
    addSponsor: 'Añadir patrocinador',
    sponsorName: 'Nombre del patrocinador',
    sponsorNameDescr: 'El nombre oficial de tu patrocinador.',
    sponsorLink: 'URL del sitio web',
    sponsorLinkDescr:
      'Proporcione un enlace a su patrocinador. Cuando un espectador hace clic en la imagen del patrocinador en el lugar del anuncio, se le enviará al enlace proporcionado.',
    sponsorLogo: 'Logo',
    sponsorLogoDescr:
      'Cargue un logotipo para su patrocinador que aparecerá en las campañas publicitarias. Recomendamos una imagen transparente con las siguientes dimensiones: {width}x{height}. Se requiere una imagen para crear un patrocinador.',
    sponsorDeleteDescr:
      'El patrocinador será eliminado de cualquier carrusel o campaña publicitaria existente al que se le haya asignado.',
    adCarousels: 'Ad Carousels',
    manageAdCarousels: 'Administrar carruseles',
    adCarouselsSubHeader:
      'Cree sus carruseles de anuncios y llénelos con los activos de su patrocinador. Un carrusel de anuncios es una lista de logotipos de patrocinadores que gira a intervalos regulares',
    addAdCarousel: 'Agregar carrusel',
    adCarouselMuteLogosDescr: 'Los logotipos del patrocinador se atenuarán.',
    adCarouselName: 'Nombre del carrusel',
    adCarouselNameDescr: 'El nombre del carrusel',
    adCarouselSponsorsDescr:
      'Arrastre y suelte patrocinadores en el área de organización del carrusel a continuación. Si se habilita el pedido, los patrocinadores se mostrarán de arriba a abajo',
    adCarouselStage: 'Etapa de carrusel',
    adCarouselSponsorsOrderDescr:
      'Los patrocinadores deben mostrarse en el orden especificado',
    adCarouselPreview: 'Vista previa del carrusel',
    adCarouselDeleteDescr:
      'Al eliminar este carrusel también se eliminarán las campañas publicitarias a las que esté asignado.',
    adCampaigns: 'Campañas publicitarias',
    manageAdCampaigns: 'Administrar campañas publicitarias',
    adCampaignsSubHeader:
      'Cree sus campañas publicitarias, asigne sus carruseles de anuncios, seleccione en qué páginas públicas se muestran sus carruseles de anuncios y configure las horas en que se muestran',
    addAdCampaign: 'Agregar campaña',
    adCampaignName: 'Nombre de la campaña',
    adCampaignNameDescr: 'Proporcione un nombre para la campaña',
    adCampaignCarousel: 'Carrusel',
    adCampaignCarouselDescr: 'Seleccione el carrusel para usar en esta campaña',
    adCampaignPages: 'Páginas',
    adCampaignAddAllPages: 'Agregar a todas las páginas disponibles',
    adCampaignPagePreview: 'Vista previa',
    adCampaignPagesDescr:
      'Seleccione todas las páginas disponibles o elija secciones específicas de cada página',
    adCampaignDates: 'Fechas',
    adCampaignDatesDescr:
      'Seleccione una fecha y hora para comenzar su campaña y finalizarla. El carrusel solo se mostrará en las páginas seleccionadas si la fecha y hora actuales están dentro de este intervalo de fechas',
    adCampaignConflictingCampaigns: 'Campañas en conflicto',
    adCampaignConflictingCampaignsWarning:
      'No puede guardar esta campaña porque entraría en conflicto con las siguientes campañas:',
    adCampaignConflictingPagesWarning:
      'Estas campañas comparten las siguientes secciones de campaña de página en un período de tiempo superpuesto:',
    adCampaignNoCarousels: 'No hay carruseles de anuncios disponibles. Cree uno utilizando la <a href="/app/competitions/{competitionId}/setup/marketing/ad-carousels/">Página de carrusel de anuncios</a>.',
    adCampaignsReport: 'Informe de anuncios',
    filter: 'Filtro',
    adCampaignsFilterDescr: 'Filtrar por campaña, carrusel o sección de página',
    carousel: 'carrusel',
    pageSlots: 'Secciones de página',
    selectCampaign: 'Seleccione una campaña ...',
    selectCarousel: 'Seleccione un carrusel ...',
    selectPageSection: 'Seleccione una sección de página ...',
    ticketLinks: 'Enlaces de tickets',
    ticketer: 'Ticketer',
    pageNotFound: 'Esa página no se pudo encontrar.',
    pleaseCheckLinkAgain:
      'Por favor revise el enlace a esta página nuevamente y asegúrese de que sea correcto.',

    noPermission: 'No tienes permiso para ver esto.',
    publishHeatAssignments: 'Publish Heat Assignments',
    areYouSurePublishHeatAssignments: 'Are you sure?',
    heatAssignmentPublishWarning:
      'After publishing, athletes will see their assignments on their personal schedule.',
    unpublishHeatAssignments: 'Unpublish Heat Assignments',
    areYouSureUnpublishHeatAssignments: 'Are you sure?',
    unpublishHeatAssignmentsWarningIntro:
      'This will remove heat assignments from public view of schedules',
    unpublishHeatAssignmentsWarningBody: '',
    confirmUnpublishHeatAssignments: 'Yes, Unpublish Heat Assignments',
    ticketing: 'Ticketing',
    spectators: 'Spectators',
    manageAssignmentsInfo:
      'Expand your segments to have access to manually select the heat/lane for each athlete',
    competitionLandingDefaultDescr: '<h1><span style="color: rgb (36, 41, 46);">Bienvenido a {competitionName}!</span></h1><p><br></p><p><span style="color: rgb(36, 41, 46);">Estamos encantados de que desee asistir a nuestro evento. Puede encontrar información sobre la fecha de la competencia, entrenamientos y divisiones en nuestra página de inicio. ¡Desde aquí, también puede registrarse, ver tablas de clasificación, comprar boletos y más!</span></p><p><br></p><p><span style="color: rgb(36, 41, 46);">Si tiene alguna pregunta, comuníquese con <a href="mailto:{competitionEmail}">{competitionEmail}</a> para asistencia.</span></p>',
    hashtagsPlaceholder: 'Agregue hashtags...',
    defaultHashtags: 'Hashtags Sugeridos',
    hashtags: 'Hashtags',
    organizerHashtagExplanation: 'Los atletas pueden usar hashtags para competir con grupos más pequeños en una tabla de clasificación personalizada.<br/>Escriba una lista de hashtags que serán sugeridos a sus atletas al momento del registro.',
    myHashtagsDescr: 'Usa hashtags para competir con tu grupo en una tabla de clasificación personalizada (#aptitud, #victorioso, etc.)',
    advancedFilters: 'Filtro de búsqueda',
    applyFilters: 'Aplicar Filtros',
    clearFilters: 'Filtros Claros',
    noMatchingAthletes: 'No hay atletas que coincidan con los filtros proporcionados.',
    filterEntriesFound: 'atletas encontrados en esta tabla de clasificación.',
    canFilterLeaderboardLabel: 'Usar como filtro de clasificación',
    canFilterLeaderboardDescr: 'Esta pregunta puede usarse para filtrar tablas de clasificación a grupos más pequeños de atletas.',
    iJustRegistered: `Me acabo de registrar para {compName} en ${SHORT_DOMAIN}!`,
    shareYourRegistration: '¡Descarga y comparte esta imagen para que tus amigos sepan que estás registrado!',
    iJustScored: `Acabo de registrar una puntuación de {score} para {workout}. ¡Mira las tablas de clasificación para {compName} en ${SHORT_DOMAIN}!`,
    shareYourScore: '¡Descarga esta imagen y comparte tu puntuación con tus amigos!',

    howToFilterModalTitle: '¿Sabías?',
    howToFilterModalBody: 'Puede buscar un atleta o crear una tabla de clasificación solo con usted y sus amigos haciendo clic en "Buscar y filtrar".',
    howToFilterModalButton: '¡Entendido!',

    howToShareModalTitle: 'Comparte tu tabla de clasificación personalizada',
    howToShareModalBody: '¡Compartir esta tabla de clasificación personalizada es tan fácil como copiar y pegar la dirección web!',
    howToShareModalButton: '¡Entendido!',

    leaderboardAutoPublishTurnedOn: 'Se ha activado la publicación automática de marcadores. <a href="/app/competitions/{competitionId}/leaderboards/settings/">Ajustes de Actualización</a>',
    leaderboardAutoPublishTurnedOff: 'Se ha desactivado la publicación automática de la tabla de clasificación. <a href="/app/competitions/{competitionId}/leaderboards/settings/">Ajustes de Actualización</a>',

    trials: {
      oneDayTrial: 'Pruébelo gratis ahora mismo!',
      yourTrialExpired: 'Tu periodo de prueba ha caducado',
      activate: '¡Activar!',
      nocc: 'No se requiere tarjeta de crédito',
      weSentARequest: 'Hemos enviado una solicitud a su representante de cuenta para activar esta función. ¡Estarán en contacto en breve!',

      sponsorship: {
        img: 'https://strongest.com/wp-content/uploads/2020/03/throwdowns-marketing-1024x525.png',
        icon: 'rectangle-ad',
        title: 'Kit de Patrocinio',
        description: '¡Desbloquee ubicaciones de logotipos únicas para sus patrocinadores y sus marcas! Este kit le permite crear contenido de patrocinio personalizado en páginas clave para aumentar los ingresos y mantener felices a sus patrocinadores.',
        features: [
          {
            icon: 'conveyor-belt-boxes',
            copy: 'Cree logotipos de patrocinadores rotativos en sus páginas de competencia más vistas.',
          },

          {
            icon: 'chart-line',
            copy: 'Garantice el valor del patrocinador con URL personalizables en sus logotipos para realizar un seguimiento de las visitas a la página y las tasas de clics.',
          },

          {
            icon: 'dollar-sign',
            copy: '¡Aumente los ingresos de su competencia atrayendo nuevos patrocinadores!',
          }
        ]
      },

      scheduling: {
        img: 'https://strongest.com/wp-content/uploads/2020/03/throwdowns-scheduling-1024x587.jpg',
        icon: 'stopwatch',
        title: 'Kit de Programación',
        description: 'La programación de calor es a menudo un "problema" de último minuto en el que los organizadores piensan demasiado tarde. Con este kit, puede crear y publicar su horario para que todos sepan qué / dónde / cuándo para cada momento de su competencia. Sus atletas, fanáticos, voluntarios y personal se lo agradecerán.',
        features: [
          {
            icon: 'clock',
            copy: 'Cree horarios que se integren a la perfección con nuestros sistemas de registro y puntuación.',
          },

          {
            icon: 'table',
            copy: 'Calcule y administre horarios dentro de la aplicación: ¡sin hojas de cálculo separadas!',
          },

          {
            icon: 'users',
            copy: '“Reinicie” a sus atletas sin dolor con nuestro Programador especialmente diseñado.',
          }
        ],
      },

      liveScoring: {
        img: 'https://strongest.com/wp-content/uploads/2020/05/throwdowns-scoring-broadcasting.png',
        icon: 'table-list',
        title: 'Kit de Puntuación en Vivo',
        description: 'Aproveche las herramientas necesarias para atraer espectadores de todo el mundo a su competencia. Vea los resultados a medida que ocurren en tiempo real, sin esperar a que termine el calor. Capacite a los comentaristas para que cuenten Y muestren una gran historia con resultados relevantes de acción en vivo basados ​​en datos en la pantalla.',
        features: [
          {
            icon: 'award',
            copy: 'Actualiza continuamente las tablas de clasificación de cada eliminatoria en tiempo real.'
          },
          {
            icon: 'tv',
            copy: 'Los gráficos basados ​​en datos publican resultados en pantallas de reloj, dispositivos móviles o cintas de puntuación en la parte superior de la pantalla.'
          },
          {
            icon: 'dollar-sign',
            copy: 'Maximice los ingresos de entradas, espectadores en línea y patrocinadores.'
          }
        ]
      },

      precisionTiming: {
        img: 'https://strongest.com/wp-content/uploads/2020/05/throwdowns-precision-timing.png',
        description: 'Deje que sus atletas terminen con fuerza con una acción enfática que no solo entretiene, sino que brinda precisión. Nuestro kit de sincronización de precisión incluye los botones, así como una integración de vanguardia con temporizadores de chip para garantizar que ejecute un evento de primer nivel con una sincronización precisa de 1/100 de segundo. No más disputas por errores humanos, no más conjeturas: solo finales espectaculares y agradables al público.',
        title: 'Kit de sincronización de precisión',
        features: [
          {
            icon: 'stopwatch',
            copy: 'Garantice la precisión sin el riesgo de errores de sincronización humana.'
          },
          {
            icon: 'trophy',
            copy: 'Cree finales emocionantes y dignos de destacar presionando un botón o cruzando una línea de meta impulsada por chips de tiempo.'
          },
          {
            icon: 'award',
            copy: 'Luzca profesional con el seguimiento de resultados automatizado y basado en tecnología.'
          }
        ]
      },

      broadcasting: {
        img:'https://strongest.com/wp-content/uploads/2020/05/throwdowns-scoring-broadcasting.png',
        icon: 'tv',
        title: 'Kit de transmisión',
        description: 'Nuestro kit de transmisión ofrece gráficos de calidad de red que se vinculan a la perfección con las fuentes de datos de nuestros sistemas de información para comentaristas y puntuación en vivo. Cada segundo que pasa es precioso durante una producción en vivo, por lo que hemos optimizado el software y los flujos de trabajo para que pueda lograr la producción de la más alta calidad con una fracción del esfuerzo típico requerido.',
      }
    },

    siteContent: {
      topLevelHelp: '<div class="content"><h2>Bienvendio</h2><p><br></p><p>Mientras interactúas con las competiciones, notarás un <strong>?</strong> icono de ayuda (Igual al que está seleccionado en el menú de la izquierda) que proporciona ayuda específica personalizada sobre cómo funciona cada parte de la aplicación.</p><p><br></p></div>',

      compSetupMarketing: '<div class="content"><h1>Consejos de configuración de marketing</h1><p>En las sub-pestañas de <strong>Marketing</strong>, puede personalizar casi todos los aspectos de marketing más importantes de su competencia. </p><ul><li>La pestaña de <strong>Organización</strong> contiene toda la información de alto nivel sobre la competencia, como el nombre, la dirección web y la foto de portada.</li><li>La pestaña de <strong>Contenido</strong> es donde puedes editar el contenido de la página de destino. Esta es la primera página que verán los usuarios cuando lleguen a tu competencia y la página principal que querrás compartir en las redes sociales para promocionar tu competencia.</li><li>La pestaña de <strong>Lugar y Tiempo</strong> es donde puede establecer la ubicación del lugar y la dirección para las competiciones en vivo. También puede establecer la fecha oficial y la zona horaria de la competencia desde este menú.</li><li>Si su competencia permite que los atletas envíen sus propios puntajes, podrá configurar los ajustes para el envío de puntajes en el apartado de la pestaña de <strong>Puntuación</strong> en línea.</li></ul><p>Consulte nuestro <a href="http://help.strongest.com/es/">Central de Ajuda<a></a> para obtener más artículos de asistencia sobre la comercialización de su evento.</div>',

      compSetupProgramming: '<div class="content"><h1>Programación</h1><p>En la subpestaña <strong>Programación</strong>, puede personalizar cada aspecto de las divisiones, entrenamientos y políticas de puntaje de su competencia.</p><ul><li>Las pestañas <strong>Divisiones</strong> y <strong>Entrenamientos</strong> le permiten administrar todas las configuraciones diferentes para sus divisiones y entrenamientos.<ul><li>Dentro de cada división / entrenamiento, puede agregar / eliminar entradas, incrustar contenido (incluidas imágenes y videos) y establecer detalles avanzados como límites de registro por división, número total de miembros del equipo o tiempos de lanzamiento del entrenamiento.</li><li>Recomendamos que incluya estándares de movimiento claros para cada entrenamiento y una breve descripción para cada división.</li></ul></li><li>La pestaña <strong> Políticas de Puntuación </strong> es donde puede establecer reglas específicas sobre cómo se calcula la puntuación.</li><ul><li>El <strong> Tipo de Puntuación </strong> afecta a todas las divisiones y entrenamientos, y determina la ubicación general del atleta en la tabla de clasificación. Recomendamos utilizar la puntuación basada en la ubicación o las tablas de puntos estándar de CrossFit® Games. Puede obtener más información sobre estos tipos de puntuación en <a href="http://help.strongest.com/es/articles/3062621-choosing-your-scoring-policies"> este artículo de ayuda </a>.</li><li>Para los entrenamientos, designará que un valor de puntaje más alto es mejor (por ejemplo, AMRAP, levantamientos de esfuerzo máximo, etc.) o un valor de puntaje más bajo es mejor (entrenamientos basados ​​en el tiempo). Puede establecer políticas de desempate, conteos de repeticiones, y el tiempo limita aquí también.</li></ul></ul><p>Recuerde: la clave para una gran programación es la simplicidad. ¡Cuanto más fácil sea para los atletas entender los estándares y cómo funciona la puntuación, mejor!</p><p>Consulte nuestro <a href="http://help.strongest.com/es/"> Centro de ayuda </a> para obtener más artículos de asistencia sobre cómo crear su programación de competencia o configurar sus políticas de puntuación.</p></div>',

      compSetupRegistration: '<div class="content"><h1>Registro</h1><p>En las subpestañas <strong>Registro</strong>, puede personalizar toda la experiencia de registro para sus atletas y voluntarios.</p><ul><li>La pestaña <strong>Contenido</strong> es donde puede personalizar el contenido que el usuario verá cuando llegue a su página de registro. Puede ingresar texto, así como incrustar imágenes y videos.</li><li>La pestaña <strong>Pagos</strong> es donde puede especificar los precios de los boletos y la moneda que se utilizará en el proceso de pago del atleta.</li><li>La pestaña <strong>La Venta al por Menor</strong> es donde puede crear y administrar artículos de mercadería adicionales que se ofrecerán en el registro. Puede configurar el nombre, el precio y la cantidad de mercancía.</li><li>La pestaña <strong>Fechas</strong> es donde puede configurar las fechas y horarios de apertura / cierre para el registro. Tenga en cuenta que la configuración de la zona horaria se aplica aquí. Puede cambiarlos en el menú de Marketing según sea necesario.</li><li>La pestaña <strong>Depósitos</strong> muestra la cuenta Stripe a la que está conectada la competencia. Su cuenta Stripe es donde recibirá depósitos a medida que sus atletas se registren.</li></ul><p>Consulte nuestro <a href="http://help.strongest.com/es/"> Centro de ayuda </a> para obtener más artículos de asistencia sobre la personalización de su registro y la gestión de sus registrantes</p></div>',

      compSetupAdvanced: '<div class="content"><h1>Configuraciones Avanzadas</h1><p>Las subpestañas <strong> Avanzado </strong> contienen varias funciones adicionales que se pueden utilizar para personalizar aún más su experiencia en la competencia, especialmente en el momento del registro.</p><ul><li>Si desea ofrecer cupones para sus atletas, puede hacerlo en la pestaña de <strong>Cupones</strong>. Puede crear cupones con una variedad de restricciones, tales como montos fijos o basados ​​en porcentajes del precio del boleto, fechas de vencimiento, números limitados de cupones, etc.</li><li>La sub-pestaña de <strong>Excensión</strong> Personalizada le permite crear una exención personalizada para el registro. Hemos proporcionado algún contenido de exención predeterminado, pero siempre recomendamos que lo revise con cuidado y use su propia exención si tiene uno que ya haya sido revisado por su equipo legal.</li><li>Puedes añadir <strong>Campos Personalizados</strong> a su formulario de registro si hay información adicional que le gustaría obtener de los atletas. Por ejemplo, a algunos organizadores les gusta preguntar a los atletas cómo se enteraron de la competencia o preguntar es la primera competencia de un atleta. Esta información se puede recuperar posteriormente a través de la función de exportación en <strong>Registrantes </strong>tab.</li><li>Es muy poco probable que deba realizar cambios en el sub menu de <strong>Políticas de Puntuación</strong> avanzadas. Si cree que su competencia tiene necesidades de puntuación especiales que las configuraciones estándar en la pestaña Programación no cubren, contáctenos y con gusto lo ayudaremos con la configuración avanzada.</li><li>El <strong>Límite de Registro</strong> es donde puede establecer un límite global en el número de inscritos de atletas permitidos para su competencia.</li><li><strong>Acceso de Registro </strong> determina si sus registrantes tienen la capacidad de actualizar su registro desde su panel de control. Esto está habilitado por defecto. Si está deshabilitado, los atletas no podrán actualizar su registro después de pagar.</li><li>Al alternar <strong> Invitaciones Necesarias </strong> se bloqueará el registro y se requerirá que los solicitantes de registro tengan una invitación para poder registrarse. Las invitaciones se envían a través de la pestaña <strong> Invitaciones</strong>.</li></ul><p>Consulte nuestro <a href="http://help.strongest.com/es/"> Centro de ayuda </a> para obtener más artículos de asistencia sobre estas funciones avanzadas.</p></div>',

      compRegistrants: '<div class="content"><h1>Inscritos</h1><p>La pestaña de <strong>Inscritos </strong> contiene informes simples que muestran quién se ha registrado para su competencia por división.</p><p>Hay un par de otras características también:</p><ul><li>Puede ver los nombres de los atletas, correos electrónicos, fecha de registro y cargos de registro. </li><li>Puedes editar el nombre de la tabla de clasificación de un atleta y cambiar su división. </li><li>Puede exportar datos de registro a todas las divisiones.</li></ul><p>La opción <strong>Solicitar Exportación </strong> en la parte superior derecha de la página le permite realizar una exportación "instantánea" de todos los datos de registro de su atleta. Una vez que esté listo, la aplicación le enviará un correo electrónico que contiene un archivo csv de todos los registrantes de yoru para un fácil almacenamiento y análisis.</p></div>',

      compScoring: '<div class="content"><h1>Inserción y Revisión de puntuación</h1><p><br></p><ul><li><span style="background-color: transparent;">Las </span>sub-pestañas<span style="background-color: transparent;"> de <strong style="background-color: transparent;">Insertar Putuación</strong> es donde vas a administrar las puntuaciones para cada una de tus divisiones.</span></li><li><span style="background-color: transparent;">Puedes usar la </span>pestaña<span style="background-color: transparent;"><strong style="background-color: transparent;"> Enlaces de Entrada de Datos</strong> para crear y compartir enlaces de "insertar puntuación en quiosco" con las personas que le gustaría asignar como delegados. Por lo general, estas personas serán miembros de su personal que ingresarán los puntajes a medida que las tarjetas de puntaje en papel lleguen al escritorio de puntaje.</span></li><li><span style="background-color: transparent;">Debajo de cada sub-pestaña de división, puedes ingresar puntuaciones y obtener una vista previa del aspecto que tendrá la tabla de clasificación cuando se publiquen las puntuaciones. Sin embargo, las tablas de clasificación públicas oficiales no se actualizarán hasta que publiques las tablas de clasificación.</span></li><li><span style="background-color: transparent;">Muchas competiciones preferirán que el MC haga una "gran revelación" al final de la competencia justo antes de la ceremonia de premiación, y la posibilidad de obtener una vista previa de una tabla de clasificación antes de publicar puede ser útil aquí.</span></li><li><span style="background-color: transparent;">Las entradas de atletas ingresadas manualmente se pueden eliminar de la tabla de puntuación eliminando completamente su nombre. Esto eliminará todos los puntajes ingresados ​​en la entrada también. &nbsp;</span></li><li><span style="background-color: transparent;">Si su competencia incluye puntajes en línea, podrá revisar (aprobar / rechazar) todos los puntajes que envíen los atletas con las herramientas de revisión de puntajes que se encuentran debajo de los submenús de nivel de división.</span></li><li><span style="background-color: transparent;">El envío de las puntuaciones en línea que se hayan aprobado se actualizará automáticamente en la tabla de clasificación pública después de un cierto tiempo (cada 5 minutos aproximadamente).</span></li></ul><p><br></p></div>',

      compSupport: '<div class="content"><h1>Soporte</h1><p><br></p><p><span style="background-color: transparent;">Todos los menús están organizados en secciones: </span><strong style="background-color: transparent;">Configuración</strong><span style="background-color: transparent;">, </span><strong style="background-color: transparent;">Administración</strong><span style="background-color: transparent;">,</span><strong style="background-color: transparent;"> </strong><span style="background-color: transparent;">y </span><strong style="background-color: transparent;">Soporte</strong></p><ul><li><span style="background-color: transparent;">Cada pestaña de la sección de </span><strong style="background-color: transparent;">Configuración </strong><span style="background-color: transparent;"> le permite modificar las configuraciones que ha seleccionado durante el proceso guiado paso a paso. Una vez que haya configurado estos ajustes correctamente, es probable que no tenga que volver atrás e interactuar con ellos una vez que se haya lanzado su competencia.</span></li><li><span style="background-color: transparent;">Cada pestaña de la sección de </span><strong style="background-color: transparent;">Administración </strong><span style="background-color: transparent;">involucra operaciones diarias para tu competencia.</span></li><li class="ql-indent-1"><span style="background-color: transparent; color: rgb(33, 35, 41);">Por ejemplo, es probable que esté vigilando de cerca las inscripciones de la </span>pestaña de los <span style="background-color: transparent; color: rgb(33, 35, 41);"><strong style="background-color: transparent;">Inscritos</strong> a medida que se llenan las incripciones.</span></li><li class="ql-indent-1"><span style="background-color: transparent; color: rgb(33, 35, 41);">Para eventos en línea, también pasará algo de tiempo en la </span>pestaña de<span style="background-color: transparent; color: rgb(33, 35, 41);"> <strong style="background-color: transparent;">Ingreso de puntajes</strong> para revisar las puntuaciones a medida que las ventanas de entrenamiento se cierran.</span></li><li class="ql-indent-1"><span style="background-color: transparent; color: rgb(33, 35, 41);">Para eventos en vivo, tu tabla de puntaje ingresará puntajes en la </span>pestaña de<span style="background-color: transparent; color: rgb(33, 35, 41);"><strong style="background-color: transparent;"> Ingreso de puntaje</strong> a lo largo del día de la competencia.</span></li><li><span style="background-color: transparent;">La </span>sección de <span style="background-color: transparent;"><strong style="background-color: transparent;">Soporte</strong> ¡será donde continuaremos creando y brindando funciones de soporte únicas para ayudarlo a mejorar su competencia!</span></li><li class="ql-indent-1"><span style="background-color: transparent;">Recuerde, siempre puede comunicarse con nosotros directamente a través de Intercom, el pequeño icono de texto negro en la parte inferior derecha de la pantalla.</span></li></ul><h2> Quickstart Video</h2><p><br></p><p>Aquí hay un video corto de ~ 2.5 minutos que creamos para brindarle una orientación rápida de cómo funciona el sistema.</p><p><br></p><iframe class="ql-video" frameborder="0" allowfullscreen="true" src="https://www.youtube.com/embed/yaTL8CPR21s?showinfo=0"></iframe><p><br></p><p><br></p></div>',

      compSetupHeatScheduling: `<div class="content"><h1>Rutina</h1><p><br><strong>¡Bienvenido a la página de ayuda para crear tu rutina!</strong></p><p>Sabes que crear tu rutina desde un borrador puede ser difícil y una ardua tarea. Por eso hemos creado una herramienta intuitiva, fácil de usar para ayudarte a crear, controlar y compartir tu rutina todo sin dañar el ecosistema de ${APP_NAME}.</p><p>Para empezar a construir tu horario, te pedimos que primero pases por nuestro mago de configuración. Este formato lo hace más fácil de dividir y trabajar en las diferentes partes de hacer un horario.</p><p>Recomendamos ampliamente que revises nuestro centro de ayuda para una guía complete en todo lo que necesitaras saber sobre nuestro planificador. Los artículos de ayuda están designados no solo para ayudarte con la parte técnica de crear un horario, sino también para reforzar las mejores prácticas y patrones usados por competencias profesionales por todo el mundo.</p><p>Si tienes alguna pregunta o necesitas ayuda en la configuración de tu horario, ¡no dudes en contactarnos por favor!</p></div>`,

      compInvitations: '<div class="content"><h1>Invitations</h1><p><strong>Welcome to the help page for Invitations!</strong></p>Through the Invitations tab, you can email invitations to your athletes, volunteers, and spectators so they can register for your event.<p><p>Some of the features include:</p><ul><li>Ability to adjust the messaging in your invitation</li><li>Dynamic invite system that sends invites in the specific order you set</li><li>Functionality for inviting users to specific divisions.</li><li>Tracking metrics so you know whether an invite has been accepted, expired, or if the email address provided is invalid.</li></ul><p>Check out our <a href="http://help.strongest.com/es/">Help Center</a> for specific support articles regarding Invitations.</div>',

      compLeaderboards: '<div class="content"><h1>Preferencias de visualización de la tabla de clasificación</h1><p><strong>¡Bienvenido a la página de ayuda para las preferencias de visualización de la tabla de clasificación!</strong></p>Esta característica le permite configurar las diversas configuraciones de visualización que desea para sus tablas de clasificación.<p><p>Algunas de las preferencias de visualización actuales y futuras para tablas de clasificación son:</p><ul><li>Posibilidad de mostrar las banderas de los países de los solicitantes de registro</li><li>(¡Próximamente!) Posibilidad de mostrar los nombres de afiliados de los solicitantes de registro</li><li>(¡Próximamente!) Posibilidad de alternar los enlaces de video de envío de puntajes para que aparezcan en la tabla de clasificación</li><li>¡Y más!</li></ul><p>A medida que continuamos construyendo ajustes de configuración, aparecerán aquí.</p><p>Si está intentando obtener una vista previa o publicar sus tablas de clasificación, lo haría desde la pestaña <strong>Entrada de puntuación</strong>, no desde esta pestaña.<p>Consulte nuestro <a href="http://help.strongest.com/es/">Centro de ayuda</a> para obtener artículos de soporte que proporcionan ejemplos de nuestras diferentes opciones de visualización de la tabla de clasificación. </div>',

      compSetupTicketing: '<div class="content"><h1>Entradas</h1><p><strong>¡Bienvenido a la página de ayuda para crear entradas para su evento!</strong></p>Esta característica le permite crear, editar y administrar las diferentes entradas que ofrecerá a sus espectadores.<p><p>Hay 3 subpestañas principales:</p><ul><li>La pestaña <strong>Contenido</strong> le permite personalizar el texto que aparecerá en la parte superior de la página de compra de boletos.</li><li>La pestaña <strong>Fechas</strong> es donde establecerá la fecha de inicio para cuando las entradas salgan a la venta y la fecha de finalización para cuando las entradas ya no estén disponibles para la compra.</li><li>La pestaña <strong>Entradas</strong> es donde puede crear, editar y eliminar sus opciones de entradas. Dentro de esta pestaña, puede configurar el precio, la cantidad, el nombre y la descripción de sus diversos boletos.</li></ul><p>Cada boleto que se vende viene con un código QR único que se envía al comprador tanto en la aplicación como por correo electrónico. Este código QR le facilita la validación de entradas para su evento en vivo.</p><p>A medida que se compran sus boletos, sus espectadores y sus boletos se completarán en la pestaña <strong>Espectadores</strong> de nivel superior. </p><p>Consulte nuestro <a href="http://help.strongest.com/es/"> Centro de ayuda </a> para obtener artículos de asistencia específicos sobre tickets.</p></div>',

      compSpectators: '<div class="content"><h1>Espectadores</h1><p><strong>¡Bienvenido a la página de ayuda para gestionar a sus espectadores!</strong></p>La subpestaña <strong>Espectadores</strong> contiene un informe simple sobre las diferentes entradas que se han comprado para su evento.<p><p>Desde esta pestaña, puede:</p><ul><li>Ver información de contacto básica de los titulares de entradas, como el nombre y el correo electrónico.</li><li>Ver el tipo de boleto comprado, su identificación única, así como su estado de canje actual.</li><li>Filtre los resultados por nombre, correo electrónico o identificación del entrada.</li></ul><p>Cada boleto que se vende viene con un código QR único que se envía al comprador tanto en la aplicación como por correo electrónico. Este código QR le facilita la validación de entradas para su evento en vivo. </p><p>Consulte nuestro <a href="http://help.strongest.com/es/">Centro de Ayuda</a> para obtener artículos de asistencia específicos sobre entradas para espectadores.</p></div>'
    },
    setADateRange: 'Establecer un intervalo de fechas',
    clearDateRange: 'Intervalo de fechas claro',
    selectAll: 'Seleccionar todo',
    selectNone: 'Seleccione Ninguno',
    close: 'Cerca',
    issueLoadingPaymentForm: 'Hubo un problema al cargar el formulario de pago. Porfavor refresca.',
    uploading: 'Subiendo ...',
    imageTooBig: 'Esa imagen es demasiado grande. El límite es de 5 MB.',
    uploadImage: 'Subir una imagen',
    clearImage: 'Imagen clara',
    youtubeEmbed: 'Insertar en YouTube',
    addVideo: 'Añadir video',
    loadingCompetition: 'Competencia de carga',
    draft: 'Sequía',
    readyToPublish: '¿Estás listo para publicar tu competencia?',
    yesPublish: '¡Sí, publicar!',
    pleaseEnterAValidEmail: 'Por favor, introduce una dirección de correo electrónico válida.',
    competition: 'Competencia',
    id: 'IDENTIFICACIÓN',
    youllBeNotifiedWhenYourExportIsReady: 'Se le notificará en breve por correo electrónico cuando su exportación esté lista.',
    deleted: 'Eliminado',
    noVideo: 'No hay video',
    url: 'URL',
    youtubeUrlDesc: 'La URL del video de YouTube.',
    image: 'Imagen',
    scoreRejection: 'Rechazo de puntuación',
    scoreRejectionDesc: 'Estás rechazando una puntuación enviada por un atleta. Esto ocultará la puntuación en la tabla de clasificación, como si no se hubiera enviado ninguna puntuación.',
    rejectReason: 'Razón del rechazo',
    rejectReasonDesc: 'Deje un comentario que explique por qué se rechazó la puntuación. Esto ayudará al atleta a comprender por qué se rechazó la presentación de su puntuación.',
    rejectAndEmailAthlete: 'Rechazar y enviar un correo electrónico al atleta',
    unreject: 'Rechazar',
    reject: 'Rechazar',
    unverify: 'Anular la verificación',
    verify: 'Verificar',
    evidence: 'Evidencia',
    noEvidence: 'Sin evidencia',
    showingTopOneHundredAthletes: 'Mostrando los 100 mejores atletas. Utilice la búsqueda para encontrar cualquier atleta con el fin de ingresar / modificar sus puntajes.',
    nameOrBibNumber: 'Nombre o número de pechera',
    spectatorFilterDesc: 'Filtrar por nombre, correo electrónico o ID de ticket',
    acceptRegistrationWaiver: 'Aceptar la exención de registro',
    appWaiver: `Exención de ${APP_NAME}`,
    compWaiver: 'Renuncia a la competencia',
    yesIAgree: 'Yes, I agree',
    yesIAgreeToBoth: 'Si, estoy de acuerdo con ambos',
    searching: 'Buscando...',
    stoppedAt: 'Se detuvo en',
    seeMore: 'Ver más',
    groupLeaderboards: 'Tablas de clasificación de grupo',
    groupLeaderboardsDesc: 'Cree tablas de clasificación combinadas agregando a los atletas en divisiones específicas.',
    divisionsMustHaveSameWorkouts: 'Las divisiones seleccionadas deben tener los mismos entrenamientos',
    showCountryFlag: 'Mostrar bandera del país',
    enableAutoPublish: 'Habilitar publicación automática',
    autopublishDesc: 'Cuando está habilitado, su tabla de clasificación se publicará automáticamente si hay algún cambio, al menos cada 10 minutos.',
    showVideoOrImage: 'Mostrar enlaces de video / imagen',
    showVideoOrImageDesc: 'Cuando se alterna, los enlaces de video / imagen se muestran en la tabla de clasificación para todos los puntajes que tienen un video o una imagen enviada. De lo contrario, los videos o las imágenes solo son visibles para el personal organizador en la tabla de puntuación.',
    discountedSubtotal: 'Subtotal descontado',
    teamMembersCantShareEmails: 'Los miembros del equipo no pueden compartir direcciones de correo electrónico, ya que cada miembro deberá iniciar sesión y firmar una renuncia.',
    needsToSignWaiver: 'Necesita firmar una renuncia',
    time: 'Hora',
    unpublishing: 'Anulando la publicación ...',
    noScore: 'Sin puntuación',
    typeAthleteAutosuggest: 'Escriba el nombre del atleta para completar la selección automáticamente y acceder a sus tarjetas de puntuación.',
    capIsGreaterThanDivisionCaps: 'Aunque este límite es válido, su valor es mayor que la suma de todos los límites de división y, por lo tanto, nunca tendrá ningún efecto visible.',
    schedulePreview: 'Vista previa del horario',
    thisRegeneratesAllHeatsWarning: 'Esto regenerará completamente los calores para esta selección y perderá las ediciones manuales que haya realizado. ¿Está seguro?',
    yesRegenerateAllHeats: 'Sí, regenerar las series',
    regenerateAllHeats: 'Regenerar las series',
    generateHeats: 'Generar calores',
    filterDivisionsDesc: 'Seleccione una división para filtrar por',
    allDivisions: 'Todas las Divisiones',
    filterWorkoutsDesc: 'Seleccione un entrenamiento para filtrar por',
    allWorkouts: 'Todos los entrenamientos',
    editHeat: 'Editar calor',
    heatTitleDesc: 'Título de la manga para mostrar el horario',
    startTime: 'Hora de inicio',
    pickAStartTime: 'Elige una hora de inicio',
    endTime: 'Hora de finalización',
    pickAnEndTime: 'Elige una hora de finalización',
    moving: 'Moviente...',
    moveHeats: 'Mueva 1 calor aquí | Mueve {n} calienta aquí',
    doneEditing: 'Edición realizada',
    recalculateAssignments: 'Recalcular asignaciones',
    updateFromLeaderboard: 'Actualización de la tabla de clasificación',
    noScoresPublished: 'No se han publicado puntuaciones',
    regenerateHeats: 'Calor regenerado',
    updateManually: 'Actualizar manualmente',
    seeding: 'Siembra',
    reset: 'Reiniciar',
    saved: 'Salvado',
    clear: 'Claro',
    addJudge: 'Agregar juez',
    emptyLane: 'Carril vacío',
    swapping: 'Intercambiando ...',
    cancelSwap: 'Cancelar intercambio',
    swap: 'Intercambio',
    addBack: 'Agregar nuevamente',
    addingBack: 'Añadiendo de nuevo ...',
    removing: 'Eliminando ...',
    yesRemove: 'Sí, quitar',
    remove: 'Eliminar',
    hasMultipleRegistrations: 'tiene múltiples registros',
    working: 'Laboral...',
    yesClearTodaysSchedule: 'Sí, borre el horario de hoy',
    youMustHaveAtLeastOneWorkoutLocation: 'Debe tener al menos una ubicación de entrenamiento.',
    youMustHaveAtLeastOneDay: 'Debes tener al menos un día.',
    addDay: 'Agregar día',
    locationSchedule: 'Horario de ubicación',
    viewScheduleByLocation: 'Ver horario por ubicación',
    viewScheduleByDay: 'View by Day',
    hideContent: 'Ocultar contenido',
    showContent: 'Contenido del show',
    deleteEvent: 'Eliminar evento',
    areYouSureYouWantToDeleteThisEvent: '¿Estás seguro de que deseas eliminar este evento?',
    editEvent: 'Editar evento',
    moveToDifferentDay: 'Mover a un día diferente',
    day: 'Día',
    moveToDifferentLocation: 'Mover a una ubicación diferente',
    move: 'Muevete',
    customize: 'Personalizar',
    scheduleStartTimeDesc: 'Elija una hora de inicio para lo que está agregando al programa',
    addToSchedule: 'Agregar a la programación',
    timeBlockTitleDesc: 'Título del bloque de tiempo para la visualización del horario',
    selectAWorkout: 'Seleccione un entrenamiento',
    heatScheduleWorkoutDesc: 'Elige un entrenamiento para el que quieras programar series',
    selectADivision: 'Seleccione una división',
    heatScheduleDivisionDesc: 'Elige una división para la que quieras programar las eliminatorias',
    eventsToSchedule: 'Eventos para programar',
    eventsToScheduleDesc: 'Seleccione uno o más eventos para los que le gustaría programar series',
    events: 'Eventos',
    timeBlock: 'Bloque de tiempo',
    currentConfiguration: 'Configuración actual',
    scheduleWorkoutTitleDesc: 'El título de la ubicación del entrenamiento que se mostrará en el programa.',
    scheduleWorkoutDescriptionDesc: 'Contenido de texto enriquecido que se mostrará en el programa de esta ubicación de entrenamiento',
    editTimeBlock: 'Editar bloque de tiempo',
    pointsTablePreview: 'Vista previa de la tabla de puntos',
    excludeWorkout: '¿Quiere excluir este entrenamiento de la clasificación de esta división?',
    confirmExcludeWorkout: 'Esta acción eliminará el entrenamiento de esta división, así como su política de puntuación. Este entrenamiento no aparecerá en la presentación de la puntuación del atleta ni en la tabla de clasificación de esta división.',
    applyToAllDivisions: '¿Quiere aplicar estos ajustes a todas las divisiones de este entrenamiento?',
    confirmApplyToAllDivisions: 'Esta acción aplicará las políticas de puntuación de entrenamiento guardadas actualmente a TODAS las divisiones. Se sobrescribirá cualquier política de puntuación existente para este entrenamiento. Esto no afectará a los entrenamientos excluidos.',
    areYouSureYouWantToProceed: '¿Estas seguro que deseas continuar?',
    yesApplyToAll: 'Sí, aplicar a todos',
    yesExclude: 'Sí, excluir',
    basicSetup: 'Configuración básica',
    brandIdentity: 'Identidad de la marca',
    pleaseLimitSenderName: 'Limite el nombre a menos de 50 caracteres y no sea una dirección de correo electrónico.',
    pleaseEnterAValidUrl: 'Por favor introduzca un URL válido.',
    theme: 'Tema',
    themeDesc: 'Elija un tema para cambiar el estilo de sus páginas de destino. Puede personalizar aún más un tema seleccionando colores que combinen con su marca.',
    currentTheme: 'Tema actual',
    themeOptions: 'Opciones de tema',
    customizeTheme: 'Tema personalizado',
    customizeThemeDesc: 'Seleccione colores para anular el tema de {name} para esta competencia.',
    primaryBrand: 'Marca principal',
    primaryText: 'Texto principal',
    primaryBackground: 'Antecedentes primarios',
    secondaryText: 'Texto secundario',
    secondaryBackground: 'Fondo secundario',
    buttonBackground: 'Fondo del botón',
    buttonText: 'Botón de texto',
    secondaryButtonBackground: 'Fondo del botón secundario',
    secondaryButtonText: 'Texto del botón secundario',
    pageBackground: 'Fondo de la página',
    thisWorkoutIsCurrentlyExcludedFrom: 'Este entrenamiento está actualmente excluido de {title}. Haga clic en <strong>Incluir</strong> para volver a agregarlo.',
    include: 'Incluir',
    activeCompetitions: 'Competiciones activas',
    eventDate: 'Fecha del evento',
    createdDate: 'Fecha de creación',
    owner: 'Dueño',
    searchForACompetition: 'Busca una competencia',
    visitLandingPage: 'Visite la página de destino',
    orgFee: 'Org. Tarifa',
    athFee: 'Ath. Tarifa',
    athPays: 'Ath. Paga',
    scoringLinks: 'Enlaces de puntuación',
    logs: 'Registros',
    timestamp: 'Marca de tiempo',
    user: 'Usuario',
    action: 'Acción',
    data: 'Datos',
    leaderboard: 'Tabla de clasificación',
    ties: 'Corbatas',
    athleteSubmitsScore: 'El atleta envía la puntuación',
    platformFee: 'Tarifa de plataforma',
    platformFeeDesc: 'La tarifa de la plataforma es una cantidad fija en la moneda de la competencia más un% de la transacción.',
    currencyDesc: 'La moneda de toda la competición, incluida la tarifa plana.',
    platformFeeFlatDesc: 'La tarifa en números enteros para {currency}. Para las monedas con base decimal, como el USD, la mayoría de las veces se multiplicará por 100 (por ejemplo, $ 5 debe ingresarse como 500).',
    downloadScoringTemplate: 'Descargar plantilla de puntuación',
    publishCompetition: 'Publicar concurso',
    unpublishCompetition: 'Anular la publicación de la competencia',
    disableScheduling: 'Deshabilitar la programación',
    enableScheduling: 'Habilitar la programación',
    disableSponsorship: 'Desactivar patrocinio',
    enableSponsorship: 'Habilitar patrocinio',
    disableDevKit: 'Desactivar el kit de desarrollo',
    enableDevKit: 'Habilitar el kit de desarrollo',
    disableRefunds: 'Desactivar reembolsos',
    enableRefunds: 'Habilitar reembolsos',
    makeRegularComptition: 'Hacer competencia regular',
    makeATestCompetition: 'Haz una competencia de prueba',
    enterEmail: 'Ingrese correo electrónico',
    getActivationLink: 'Obtener enlace de activación',
    processing: 'Procesando...',
    rejected: 'Rechazado',
    refunded: 'Reintegrado',
    reverse: 'Contrarrestar',
    refund: 'Reembolso',
    testError: 'Error de prueba',
    testRejection: 'Prueba de rechazo',
    staffDashboard: 'Panel de personal',
    newUsers: 'Usuarios nuevos',
    createdCompetitions: 'Concursos creados',
    refundRequests: 'Solicitudes de reembolso',
    emailActivationLinks: 'Vínculos de activación por correo electrónico',
    youDoNotHavePermission: 'No parece que esté autorizado para acceder a esto.',
    ticketsNameDesc: 'Nombre de la persona que debe recibir las entradas.',
    ticketsEmailDesc: 'Correo electrónico de la persona que debe recibir las entradas.',
    details: 'Detalles',
    yourRevenue: 'Sus ingresos',
    collectedFees: 'Tarifas cobradas',
    transactions: 'Actas',
    nevermind: 'No importa',
    yesCancel: 'Si, cancelar',
    notEnoughFunds: 'Recarga la cuenta de Stripe para reembolsar',
    all: 'Todas',
    orLess: 'o menos',
    enterRefundAmount: 'Ingrese una cantidad para reembolsar.',
    refundHigherThanRevenue: 'Esto es más que la transacción original por',
    tooMuch: 'Demasiado',
    deleteRegistrationAndPurchases: 'Eliminar registro y / o compras.',
    whatDivisionsWillYouBeFeaturing: '¿Qué divisiones estarás presentando?',
    whatDivisionsWillYouBeFeaturingDesc: 'Hemos agregado algunos ejemplos para que pueda comenzar. Puede arrastrar & amp; suelte cada división para reordenar su posición en la lista.',
    purchasesDisabled: 'Compras deshabilitadas',
    purchasesDisabledDesc: 'Actualmente, las compras están deshabilitadas. Por favor, inténtelo de nuevo más tarde.',
    addARegistration: 'Agregar un registro',
    mustBeLoggedInForFeature: 'Debe iniciar sesión para esta función.',
    scheduleHasntBeenPublished: 'Aún no se ha publicado un horario.',
    heats: 'Calienta',
    mySchedule: 'Mi horario',
    stripeDashboard: 'Panel de control de rayas',
    chargesAreDisabled: 'Los cargos están actualmente deshabilitados hasta que se resuelva el problema con su cuenta de Stripe.',
    areYouSureYouWantToDeleteThat: '¿Está seguro de que desea eliminar <strong>{that}</strong> ?',
    custom: 'Personalizado',
    editDay: 'Editar día',
    dayTitleDesc: 'El título de su día que se mostrará en el horario.',
    dayDescriptionDesc: 'Contenido de texto enriquecido que se mostrará en la programación de este día.',
    whatDayIsThis: 'Que dia es este',
    editWorkoutLocation: 'Editar la ubicación del entrenamiento',
    addWorkoutLocation: 'Agregar ubicación de entrenamiento',
    pasteYourYouTubeUrl: 'Pega tu URL de YouTube',
    country: 'País',
    searchForAnAthlete: 'Busque un atleta.',
    member: 'Miembro',
    changeDivision: 'División de cambio',
    leaderboardPolicy: 'Política de clasificación',
    leaderboardPolicyDesc: 'Seleccione la política de puntuación que se utilizará para clasificar las puntuaciones de la tabla de clasificación de esta división.',
    customPoints: 'Puntos personalizados',
    customPointsDesc: 'Puntos delimitados por comas, en orden de ubicación, para su tabla de puntos personalizados.',
    leaderboardTiePolicy: 'Política de empate en la tabla de clasificación',
    leaderboardTiePolicyDesc: 'Seleccione la política que se utilizará para romper empates en la clasificación general de esta tabla de clasificación.',
  },

  dateTimeFormats: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },

  numberFormats: {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  }
};
